// @ts-check
const constants = {
  COMPONENT_VIEW_EVENT: {
    category: 'COMPONENT_VIEW_EVENT',
    eventType: 'view_item',
    eventParams: {item_id: 'itemId', item_name: 'itemName', item_category: 'itemCategory'},
    desc: 'text text text',
  },
  SET_ADDRESS: {
    category: 'SET_ADDRESS',
    eventType: 'submit new address',
    eventParams: ['city', 'cityName', 'streetName'],
  },
  GET_TECHNICIAN_TIMESLOTS: {
    category: 'GET_TECHNICIAN_TIMESLOTS',
    eventType: 'GET technician time slots',
    eventParams: ['city', 'zipCode'],
  },
  SELECT_TECHNICIAN_TIMESLOT: {
    category: 'SELECT_TECHNICIAN_TIMESLOT',
    eventType: 'select technician time slot',
    eventParams: ['arrivalTime'],
  },
  //example without params
  // SELECT_TECHNICIAN_TIMESLOT_TEST: {
  //   category: 'SELECT_TECHNICIAN_TIMESLOT',
  //   eventType: 'select technician time slot',
  // },
  GET_DELIVERY_TIMESLOTS: {
    category: 'GET_DELIVERY_TIMESLOTS',
    eventType: 'GET delivery time slots',
    eventParams: ['city', 'street', 'homeNum', 'products'],
  },
  //סלקום חו"ל
  ABROAD_PRIVATE_SALE: {
    category: 'hul_sale_private',
    eventType: 'visibility_16',
    eventParams: 'element_19',
  },
  //חו"ל שלי
  ABROAD_MY_ABROAD_ENTER_LOBBY: {
    category: 'hul_sheli',
    eventType: 'visibility_1',
    eventParams: 'element_1',
  },
  ABROAD_MY_ABROAD_CLICK_DISCONNECT_MY_ACCOUNT: {
    category: 'hul_sheli',
    eventType: 'click_1',
    eventParams: 'element_2',
  },
  ABROAD_MY_ABROAD_DISPLAY_MODE_TYPE: {
    category: 'hul_sheli',
    eventType: 'visibility_2',
    eventParams: '',
  },
  ABROAD_MY_ABROAD_DISPLAY_WARNING_TYPE: {
    category: 'hul_sheli',
    eventType: 'visibility_3',
    eventParams: '',
  },
  ABROAD_MY_ABROAD_CLICK_SHOW_ALL_USAGES: {
    category: 'hul_sheli',
    eventType: 'click_2',
    eventParams: 'element_3',
  },
  ABROAD_MY_ABROAD_CLICK_WARNING_BTN: {
    category: 'hul_sheli',
    eventType: 'click_3',
    eventParams: '',
  },
  ABROAD_MY_ABROAD_PACKAGE_EXISTS_DISPLAY: {
    category: 'hul_sheli',
    eventType: 'visibility_4',
    eventParams: '',
  },
  ABROAD_MY_ABROAD_PACKAGE_EXISTS_CLICK_EXPAND: {
    category: 'hul_sheli',
    eventType: 'click_4',
    eventParams: '',
  },
  ABROAD_MY_ABROAD_PACKAGE_EXISTS_CLICK_DATE_CHANGE: {
    category: 'hul_sheli',
    eventType: 'click_5',
    eventParams: '',
  },
  ABROAD_MY_ABROAD_PACKAGE_EXISTS_CLICK_REMOVE_PACKAGE: {
    category: 'hul_sheli',
    eventType: 'click_6',
    eventParams: '',
  },
  ABROAD_MY_ABROAD_PACKAGE_CLICK_HOW_DIFF_STATE_PRICE: {
    category: 'hul_sheli',
    eventType: 'click_7',
    eventParams: '',
  },
  ABROAD_MY_ABROAD_SHOW_POP_UP_REMOVE_PACKAGE: {
    category: 'hul_sheli',
    eventType: 'visibility_10',
    eventParams: 'element_15',
  },
  ABROAD_MY_ABROAD_CLICK_POP_UP_REMOVE_PACKAGE_GO_BACK: {
    category: 'hul_sheli',
    eventType: 'click_15',
    eventParams: 'element_16',
  },
  ABROAD_MY_ABROAD_CLICK_POP_UP_REMOVE_PACKAGE_REMOVE_BTN: {
    category: 'hul_sheli',
    eventType: 'click_16',
    eventParams: 'element_17',
  },
  ABROAD_MY_ABROAD_CLICK_POP_UP_DISPLAY_COUNTRIES: {
    category: 'hul_sheli',
    eventType: 'visibility_11',
    eventParams: 'element_18',
  },
  ABROAD_MY_ABROAD_CLICK_POP_UP_DISPLAY_COUNTRIES_PICK_COUNTRY: {
    category: 'hul_sheli',
    eventType: 'visibility_12',
    eventParams: '',
  },
  ABROAD_MY_ABROAD_CLICK_POP_UP_DISPLAY_COUNTRIES_CLICK_GO_BACK: {
    category: 'hul_sheli',
    eventType: 'click_17',
    eventParams: 'element_19',
  },
  ABROAD_MY_ABROAD_CLICK_POP_UP_CLICK_DISPLAY_EXTRA_INFO: {
    category: 'hul_sheli',
    eventType: 'click_18',
    eventParams: 'element_20',
  },
  ABROAD_MY_ABROAD_DISPLAY_CHANGE_START_DATE_POP_UP: {
    category: 'hul_sheli',
    eventType: 'visibility_13',
    eventParams: 'element_22',
  },
  ABROAD_MY_ABROAD_CLICK_CHANGE_START_DATE_POP_UP: {
    category: 'hul_sheli',
    eventType: 'click_20',
    eventParams: 'element_23',
  },
  ABROAD_MY_ABROAD_CLICK_STICKY_FOOTER: {
    category: 'hul_sheli',
    eventType: 'click_9',
    eventParams: 'element_5',
  },
  ABROAD_MY_ABROAD_SHOW_EXTENDED_SURF_POP_UP: {
    category: 'hul_sheli',
    eventType: 'visibility_6',
    eventParams: 'element_6',
  },
  ABROAD_MY_ABROAD_CLICK_BUY_EXTENDED_SURF_POP_UP: {
    category: 'hul_sheli',
    eventType: 'click_10',
    eventParams: 'element_7',
  },
  ABROAD_MY_ABROAD_CLICK_QUIT_EXTENDED_SURF_POP_UP: {
    category: 'hul_sheli',
    eventType: 'click_11',
    eventParams: 'element_8',
  },
  ABROAD_MY_ABROAD_SHOW_SUCCESSFUL_INSTALL_PACKAGE_POP_UP: {
    category: 'hul_sheli',
    eventType: 'visibility_7',
    eventParams: 'element_9',
  },
  ABROAD_MY_ABROAD_CLICK_SUCCESSFUL_INSTALL_PACKAGE_POP_UP: {
    category: 'hul_sheli',
    eventType: 'click_12',
    eventParams: 'element_10',
  },
  ABROAD_MY_ABROAD_SHOW_FAILED_INSTALL_PACKAGE_POP_UP: {
    category: 'hul_sheli',
    eventType: 'visibility_8',
    eventParams: 'element_11',
  },
  ABROAD_MY_ABROAD_SHOW_CANCEL_PACKAGE_POP_UP: {
    category: 'hul_sheli',
    eventType: 'visibility_9',
    eventParams: 'element_12',
  },
  ABROAD_MY_ABROAD_CLICK_CANCEL_PACKAGE_POP_UP: {
    category: 'hul_sheli',
    eventType: 'click_13',
    eventParams: 'element_13',
  },
  ABROAD_MY_ABROAD_CLICK_DO_NOT_CANCEL_PACKAGE_POP_UP: {
    category: 'hul_sheli',
    eventType: 'click_14',
    eventParams: 'element_14',
  },
  ABROAD_DATAUSAGES_SHOW: {
    category: 'hul_sheli',
    eventType: 'visibility_14',
    eventParams: '',
  },
  ABROAD_DATAUSAGES_BACKTOLOBBYCLICK: {
    category: 'hul_sheli',
    eventType: 'click_21',
    eventParams: 'element_24',
  },
  ABROAD_DATAUSAGES_TOOLTIPCLICK: {
    category: 'hul_sheli',
    eventType: 'click_22',
    eventParams: '',
  },
  ABROAD_DATAUSAGES_LASTUSESCLICK: {
    category: 'hul_sheli',
    eventType: 'click_23',
    eventParams: '',
  },
  ABROAD_DATAUSAGES_PREVIOUSCYCLECLICK: {
    category: 'hul_sheli',
    eventType: 'click_24',
    eventParams: 'element_25',
  },
  ABROAD_DATAUSAGES_BUYPACKAGECLICK: {
    category: 'hul_sheli',
    eventType: 'click_25',
    eventParams: 'element_26',
  },
  // Abroad Family From Package Exists
  ABROAD_FAMILY_CLICK_ADD_FAMILY_MEMBER_PACKAGE: {
    category: 'hul_family_private',
    eventType: 'click_1',
    eventParams: '',
  },
  ABROAD_FAMILY_DISPLAY_SUMMARY_DEAL_ON_TICKET: {
    category: 'hul_family_private',
    eventType: 'visibility_1',
    eventParams: 'element_1',
  },
  ABROAD_FAMILY_CLICK_SEND_VEREFICATION_CODE: {
    category: 'hul_family_private',
    eventType: 'click_2',
    eventParams: 'element_2',
  },
  ABROAD_FAMILY_DISPLAY_OTP_INPUT_BOXES: {
    category: 'hul_family_private',
    eventType: 'visibility_2',
    eventParams: 'element_3',
  },
  ABROAD_FAMILY_CLICK_CONTINUE_BTN_FOLLOW_OTP_INPUT: {
    category: 'hul_family_private',
    eventType: 'click_3',
    eventParams: 'element_4',
  },
  ABROAD_FAMILY_DISPLAY_SUMMAY_TICKET_POST_OTP: {
    category: 'hul_family_private',
    eventType: 'visibility_3',
    eventParams: 'element_5',
  },
  ABROAD_FAMILY_CLICK_INSTALL_PACKAGE: {
    category: 'hul_family_private',
    eventType: 'click_4',
    eventParams: 'element_6',
  },
  ABROAD_FAMILY_SUCCSESFULL_SCREEN_AFTER_INSTALL: {
    category: 'hul_family_private',
    eventType: 'visibility_4',
    eventParams: 'element_7',
  },
  ABROAD_FAMILY_FAILED_GENERAL_ERROR_SCREEN_AFTER_INSTALL: {
    category: 'hul_family_private',
    eventType: 'visibility_5',
    eventParams: 'element_8',
  },
  ABROAD_FAMILY_FAILED_INSTALL_REACH_LIMIT: {
    category: 'hul_family_private',
    eventType: 'visibility_6',
    eventParams: 'element_9',
  },
  // Abroad Family From Ticket
  ABROAD_FAMILY_CLICK_BUY_FAMILY_PACKAGE_TICKET_FLOW: {
    category: 'hul_family_private',
    eventType: 'click_5',
    eventParams: 'element_10',
  },
  ABROAD_FAMILY_SHOW_SUMMARY_PAGE_INITIAL_TICKET_FLOW: {
    category: 'hul_family_private',
    eventType: 'visibility_7',
    eventParams: 'element_11',
  },
  ABROAD_FAMILY_CLICK_SEND_VEREFICATION_CODE_TICKET_FLOW: {
    category: 'hul_family_private',
    eventType: 'click_6',
    eventParams: 'element_12',
  },
  ABROAD_FAMILY_DISPLAY_OTP_INPUT_BOXES_TICKET_FLOW: {
    category: 'hul_family_private',
    eventType: 'visibility_8',
    eventParams: 'element_13',
  },
  ABROAD_FAMILY_CLICK_CONTINUE_BTN_FOLLOW_OTP_INPUT_TICKET_FLOW: {
    category: 'hul_family_private',
    eventType: 'click_7',
    eventParams: 'element_14',
  },
  ABROAD_FAMILY_DISPLAY_SUMMAY_TICKET_POST_OTP_TICKET_FLOW: {
    category: 'hul_family_private',
    eventType: 'visibility_9',
    eventParams: 'element_15',
  },
  ABROAD_FAMILY_CLICK_INSTALL_PACKAGE_TICKET_FLOW: {
    category: 'hul_family_private',
    eventType: 'click_8',
    eventParams: 'element_16',
  },
  ABROAD_FAMILY_SUCCSESFULL_SCREEN_AFTER_INSTALL_TICKET_FLOW: {
    category: 'hul_family_private',
    eventType: 'visibility_10',
    eventParams: 'element_17',
  },
  ABROAD_FAMILY_FAILED_GENERAL_ERROR_SCREEN_AFTER_INSTALL_TICKET_FLOW: {
    category: 'hul_family_private',
    eventType: 'visibility_11',
    eventParams: 'element_18',
  },
  ABROAD_FAMILY_FAILED_INSTALL_REACH_LIMIT_TICKET_FLOW: {
    category: 'hul_family_private',
    eventType: 'visibility_12',
    eventParams: 'element_19',
  },
  // Disconnect process:
  ENTER_DISCONNECT_MAIN_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'visibility_1', // equal to event action
    eventParams: 'screen_1', // equal to event label
  },
  DISCONNECT_CLICK_ON_GET_BACK_TO_ME: {
    category: 'unsubscribe_products',
    eventType: 'click_1',
    eventParams: 'button_1',
  },
  DISCONNECT_CHOOSE_SERVICE_TO_DISCONNECT: {
    category: 'unsubscribe_products',
    eventType: 'click_2',
    eventParams: ['title'],
  },
  DISCONNECT_CLICK_ON_BUTTON_FINISH_CONDITION_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS: {
    category: 'unsubscribe_products',
    eventType: 'click_3',
    eventParams: 'button_2',
  },
  // Disconnect product can't be disconnected online:
  DISCONNECT_ENTERED_WE_SORRY_YOU_CHOOSE_TO_DISCONNECT: {
    category: 'unsubscribe_products',
    eventType: 'visibility_3',
    eventParams: 'screen_3',
  },
  DISCONNECT_CLICK_ON_FINISH_INSIDE_CALLBACK: {
    category: 'unsubscribe_products',
    eventType: 'click_4',
    eventParams: 'button_3',
  },
  DISCONNECT_ENTER_SUCCESS_CALLBACK_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'visibility_4',
    eventParams: 'screen_4',
  },
  DISCONNECT_CLICK_FINISH_IN_SUCCESS_CALLBACK_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'click_5',
    eventParams: 'button_4',
  },
  DISCONNECT_ENTER_UNSUCCESSFUL_CALLBACK_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'visibility_5',
    eventParams: 'screen_5',
  },
  DISCONNECT_CLICK_FINISH_IN_UNSUCCESSFUL_CALLBACK_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'click_6',
    eventParams: 'button_5',
  },
  DISCONNECT_ENTER_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS: {
    category: 'unsubscribe_products',
    eventType: 'visibility_6',
    eventParams: 'screen_6',
  },
  DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_CLICK_FINISH: {
    category: 'unsubscribe_products',
    eventType: 'click_7',
    eventParams: 'button_6',
  },
  DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_SUCCESS_CALLBACK_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'visibility_7',
    eventParams: 'screen_7',
  },
  DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_SUCCESS_CALLBACK_CLICK_ON_FINISH: {
    category: 'unsubscribe_products',
    eventType: 'click_8',
    eventParams: 'button_7',
  },
  DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_ENTER_UNSUCCESS_CALLBACK: {
    category: 'unsubscribe_products',
    eventType: 'visibility_8',
    eventParams: 'screen_8',
  },
  DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_CLICK_ON_FINISH_IN_UNSUCCESS_CALLBACK: {
    category: 'unsubscribe_products',
    eventType: 'click_9',
    eventParams: 'button_8',
  },
  // Disconnect TV / Internet
  DISCONNECT_ENTER_PAGE_DISCONNECT_REASONS: {
    category: 'unsubscribe_products',
    eventType: 'visibility_9',
    eventParams: '',
  },
  DISCONNECT_CLICK_AND_CHOOSE_REASONS_TO_DISCONNECT: {
    category: 'unsubscribe_products',
    eventType: 'click_10',
    eventParams: ['serviceType', 'reason'],
  },
  DISCONNECT_CLICK_ON_CONTINUE_DISCONNECT_REASONS: {
    category: 'unsubscribe_products',
    eventType: 'click_11',
    eventParams: ['serviceType', 'reasonsCount'],
  },
  DISCONNECT_ENTER_WE_WOULD_LIKE_TO_HELP_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'visibility_10',
    eventParams: '',
  },
  DISCONNECT_CLICK_ON_CALL_ME_BACK_HOW_CAN_WE_HELP_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'click_12',
    eventParams: '',
  },
  DISCONNECT_CLICK_WANT_TO_DISCONNECT_HOW_CAN_WE_HELP_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'click_13',
    eventParams: '',
  },
  DISCONNECT_ENTER_CALLBACK_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'visibility_11',
    eventParams: '',
  },
  DISCONNECT_CLICK_CONTINUE_CALLBACK_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'click_14',
    eventParams: '',
  },
  DISCONNECT_ENTER_WE_GLAD_YOU_GAVE_SECOND_CHANCE_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'visibility_12',
    eventParams: '',
  },
  DISCONNECT_CLICK_FINISH_WE_GLAD_YOU_GAVE_SECOND_CHANCE: {
    category: 'unsubscribe_products',
    eventType: 'click_15',
    eventParams: [],
  },
  DISCONNECT_ENTER_FAILED_TO_CALLBACK_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'visibility_13',
    eventParams: '',
  },
  DISCONNECT_CLICK_FINISH_IN_FAILED_TO_CALLBACK_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'click_16',
    eventParams: '',
  },
  DISCONNECT_ENTER_DISCONNECT_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'visibility_14',
    eventParams: '',
  },
  DISCONNECT_CLICK_CONTINUE_DISCONNECT_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'click_17',
    eventParams: '',
  },
  DISCONNECT_ENTER_PRODUCT_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'visibility_15',
    eventParams: '',
  },
  DISCONNECT_CLICK_SHOW_PRODUCT: {
    category: 'unsubscribe_products',
    eventType: 'click_18',
    eventParams: '',
  },
  DISCONNECT_CLICK_CONTINUE_PRODUCTS_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'click_19',
    eventParams: '',
  },
  DISCONNECT_ENTER_DELIVERY_PRODUCT_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'visibility_16',
    eventParams: '',
  },
  DISCONNECT_CLICK_CONTINUE_PRODUCT_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'click_20',
    eventParams: '',
  },
  DISCONNECT_CLICK_ON_SELF_CARE_CENTER_PRODUCT_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'click_21',
    eventParams: '',
  },
  DISCONNECT_ENTER_SUMMARIZE_DISCONNECT_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'visibility_17',
    eventParams: '',
  },
  DISCONNECT_CLICK_ON_VIEW_PRODUCTS_IN_DISCONNECT_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'click_22',
    eventParams: '',
  },
  DISCONNECT_CLICK_ON_SELF_CARE_CENTER_SUMMARIZE_DISCONNECT_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'click_23',
    eventParams: [],
  },
  DISCONNECT_CLICK_CONTINUE_SUMMARIZE_DISCONNECT_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'click_24',
    eventParams: ['serviceType', 'filledEmail'],
  },
  DISCONNECT_SAW_ARE_YOU_SURE_TO_DISCONNECT_POP_UP: {
    category: 'unsubscribe_products',
    eventType: 'visibility_18',
    eventParams: [],
  },
  DISCONNECT_CLICK_DISCONNECT_ME_IN_POP_UP: {
    category: 'unsubscribe_products',
    eventType: 'click_25',
    eventParams: '',
  },
  DISCONNECT_CLICK_THINK_ABOUT_IT_ME_IN_POP_UP: {
    category: 'unsubscribe_products',
    eventType: 'click_26',
    eventParams: '',
  },
  DISCONNECT_ENTER_SUCCESSFUL_DISCONNECT_SUMMARY_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'visibility_19',
    eventParams: '',
  },
  DISCONNECT_CLICK_ON_VIEW_PRODUCTS_IN_SUCCESSFUL_DISCONNECT_SUMMARY_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'click_27',
    eventParams: '',
  },
  DISCONNECT_CLICK_ON_SELF_CARE_CENTER_DISCONNECT_SUMMARY_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'click_28',
    eventParams: '',
  },
  DISCONNECT_ENTER_UNSUCCESSFUL_DISCONNECT_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'visibility_20',
    eventParams: '',
  },
  DISCONNECT_ENTER_PAGE_WE_DONE_DISCONNECT_BUT_FAILED_DELIVERY: {
    category: 'unsubscribe_products',
    eventType: 'visibility_34',
    eventParams: '',
  },
  DISCONNECT_SHOW_BOX_WE_DONE_DISCONNECT_BUT_FAILED_DELIVERY: {
    category: 'unsubscribe_products',
    eventType: 'visibility_35',
    eventParams: '',
  },
  DISCONNECT_CLICK_FINISH_AT_PAGE_WE_DONE_DISCONNECT_BUT_FAILED_DELIVERY: {
    category: 'unsubscribe_products',
    eventType: 'click_42',
    eventParams: '',
  },
  DISCONNECT_CLICK_ON_I_PREFER_TO_RETURN_EQUIPMENT_MYSELF_FAILED_DISCONNECT_IN_CALLBACK: {
    category: 'unsubscribe_products',
    eventType: 'click_43',
    eventParams: '',
  },
  // Disconnect cellular:
  DISCONNECT_ENTER_PAGE_DISCONNECT_REASONS_CELLULAR: {
    category: 'unsubscribe_products',
    eventType: 'visibility_21',
    eventParams: 'screen_9',
  },
  DISCONNECT_CLICK_AND_CHOOSE_REASONS_TO_DISCONNECT_CELLULAR: {
    category: 'unsubscribe_products',
    eventType: 'click_29',
    eventParams: ['reason', 'reasonsCount'],
  },
  DISCONNECT_ENTER_WE_WOULD_LIKE_TO_HELP_PAGE_CELLULAR: {
    category: 'unsubscribe_products',
    eventType: 'visibility_22',
    eventParams: 'screen_10',
  },
  DISCONNECT_CLICK_ON_CALL_ME_BACK_HOW_CAN_WE_HELP_PAGE_CELLULAR: {
    category: 'unsubscribe_products',
    eventType: 'click_30',
    eventParams: 'button_9',
  },
  DISCONNECT_CLICK_WANT_TO_DISCONNECT_HOW_CAN_WE_HELP_PAGE_CELLULAR: {
    category: 'unsubscribe_products',
    eventType: 'click_31',
    eventParams: 'button_10',
  },
  DISCONNECT_ENTER_CALLBACK_PAGE_CELLULAR: {
    category: 'unsubscribe_products',
    eventType: 'visibility_23',
    eventParams: 'screen_11',
  },
  DISCONNECT_CLICK_CONTINUE_CALLBACK_PAGE_CELLULAR: {
    category: 'unsubscribe_products',
    eventType: 'click_32',
    eventParams: 'button_11',
  },
  DISCONNECT_ENTER_WE_GLAD_YOU_GAVE_SECOND_CHANCE_PAGE_CELLULAR: {
    category: 'unsubscribe_products',
    eventType: 'visibility_24',
    eventParams: 'screen_12',
  },
  DISCONNECT_CLICK_FINISH_WE_GLAD_YOU_GAVE_SECOND_CHANCE_CELLULAR: {
    category: 'unsubscribe_products',
    eventType: 'click_33',
    eventParams: 'button_12',
  },
  DISCONNECT_ENTER_FAILED_TO_CALLBACK_PAGE_CELLULAR: {
    category: 'unsubscribe_products',
    eventType: 'visibility_25',
    eventParams: 'screen_13',
  },
  DISCONNECT_CLICK_FINISH_IN_FAILED_TO_CALLBACK_PAGE_CELLULAR: {
    category: 'unsubscribe_products',
    eventType: 'click_34',
    eventParams: 'button_13',
  },
  DISCONNECT_ENTER_DISCONNECT_CELLULAR_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'visibility_26',
    eventParams: 'screen_14',
  },
  DISCONNECT_CLICK_ON_UPGRADE_CELLULAR_PACKAGE: {
    category: 'unsubscribe_products',
    eventType: 'click_35',
    eventParams: 'button_14',
  },
  DISCONNECT_CLICK_ON_VIEW_PDF_PROGRAM_CELLULAR: {
    category: 'unsubscribe_products',
    eventType: 'click_36',
    eventParams: 'button_15',
  },
  DISCONNECT_CLICK_ON_CONTINUE_DISCONNECT_CELLULAR_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'click_37',
    eventParams: 'button_16',
  },
  DISCONNECT_ENTER_UPGRADED_CELLULAR_NEW_PACKAGE: {
    category: 'unsubscribe_products',
    eventType: 'visibility_27',
    eventParams: 'screen_15',
  },
  DISCONNECT_FAILED_TO_ENTER_UPGRADED_CELLULAR_NEW_PACKAGE: {
    category: 'unsubscribe_products',
    eventType: 'visibility_28',
    eventParams: 'screen_16',
  },
  DISCONNECT_ENTER_SCHEDULE_WHEN_WE_PART_PAGE_CELLULAR: {
    category: 'unsubscribe_products',
    eventType: 'visibility_29',
    eventParams: 'screen_17',
  },
  DISCONNECT_CLICK_CONTINUE_IN_SCHEDULE_WHEN_WE_PART_PAGE_CELLULAR: {
    category: 'unsubscribe_products',
    eventType: 'click_38',
    eventParams: '',
  },
  DISCONNECT_ENTER_SUMMARY_DISCONNECT_PAGE_CELLULAR: {
    category: 'unsubscribe_products',
    eventType: 'visibility_30',
    eventParams: 'screen_18',
  },
  DISCONNECT_CLICK_CONTINUE_IN_SUMMARY_DISCONNECT_PAGE_CELLULAR: {
    category: 'unsubscribe_products',
    eventType: 'click_39',
    eventParams: ['filledEmail'],
  },
  DISCONNECT_VIEW_ARE_YOU_SURE_POPUP_IN_SUMMARY_DISCONNECT_PAGE_CELLULAR: {
    category: 'unsubscribe_products',
    eventType: 'visibility_31',
    eventParams: 'screen_19',
  },
  DISCONNECT_CLICK_DISCONNECT_ME_IN_POPUP_CELLULAR: {
    category: 'unsubscribe_products',
    eventType: 'click_40',
    eventParams: 'button_17',
  },
  DISCONNECT_CLICK_THINK_ABOUT_IT_IN_POPUP_CELLULAR: {
    category: 'unsubscribe_products',
    eventType: 'click_41',
    eventParams: 'button_18',
  },
  DISCONNECT_ENTER_SUMMARY_CONCLUDE_PAGE_CELLULAR: {
    category: 'unsubscribe_products',
    eventType: 'visibility_32',
    eventParams: 'screen_20',
  },
  DISCONNECT_FAILED_TO_DISCONNECT_CELLULAR_PAGE: {
    category: 'unsubscribe_products',
    eventType: 'visibility_33',
    eventParams: 'screen_21',
  },
  // SelfCare NavBar Lobby
  SELF_CARE_NAV_CLICK_ON_CHOOSE_TAB_OPTION: {
    category: 'personal_area_private',
    eventType: 'click_2',
    eventParams: '',
  },
  SELF_CARE_CLICK_ON_ACTION_BOX: {
    category: 'personal_area_private',
    eventType: 'click_3',
    eventParams: '',
  },
  // Our Products Lobby
  OUR_PRODUCTS_CLICK_ON_JOIN: {
    category: 'personal_area_private',
    eventType: 'click_7',
    eventParams: '',
  },
  OUR_PRODUCTS_SHOW_PRODUCT_BOX: {
    category: 'personal_area_private',
    eventType: 'visibility_4',
    eventParams: '',
  },
  SELF_CARE_INVOICES_BLOCK_LOADED: {
    category: 'personal_area_private',
    eventType: 'visibility_3',
    eventParams: '',
  },
  SELF_CARE_INVOICES_PREVIOUS_BILLS_OPENED: {
    category: 'personal_area_private',
    eventType: 'click_6',
    eventParams: 'previous_invoices_link',
  },
  SELF_CARE_INVOICES_LAST_INVOICE_CLICK: {
    category: 'personal_area_private',
    eventType: 'click_4',
    eventParams: 'last_invoice',
  },
  SELF_CARE_INVOICES_PREVIOUS_INVOICE_CLICK: {
    category: 'personal_area_private',
    eventType: 'click_5',
    eventParams: 'previous_invoices',
  },
  // Business Portal Page
  BUSINESS_PORTAL_ENTER_PORTAL: {
    category: 'personal_area_business',
    eventType: 'lobby_entrance',
    eventParams: '',
  },
  BUSINESS_PORTAL_CLICK_ON_PORTAL: {
    category: 'personal_area_business',
    eventType: 'click_1',
    eventParams: '',
  },
  BUSINESS_PORTAL_REPORT_PORTAL_AMOUNT: {
    category: 'personal_area_business',
    eventType: 'visibility_1',
    eventParams: '',
  },
  BUSINESS_PORTAL_RENDER_AFTER_CHOICE: {
    category: 'personal_area_business',
    eventType: 'visibility_2',
    eventParams: 'PV_after_BN',
  },
  BUSINESS_PORTAL_RENDER_PORTAL: {
    category: 'personal_area_business',
    eventType: 'visibility_3',
    eventParams: '',
  },
  BUSINESS_PORTAL_CLICK_ON_ACTION_BOX: {
    category: 'personal_area_business',
    eventType: 'click_2',
    eventParams: '',
  },

  // Debt payment
  DEBT_PAYMENT_START: {
    category: 'debit_payment_business',
    eventType: 'visibility_1',
    eventParams: 'screen_1',
  },
  DEBT_PAYMENT_CLICK_COMPANYLIST: {
    category: 'debit_payment_business',
    eventType: 'click_1',
    eventParams: 'button_1',
  },
  DEBT_PAYMENT_SHOW_COMPANYLIST_EMPTY: {
    category: 'debit_payment_business',
    eventType: 'visibility_2',
    eventParams: 'screen_2',
  },
  DEBT_PAYMENT_CLICK_CHOOSECOMPANY: {
    category: 'debit_payment_business',
    eventType: 'click_3',
    eventParams: 'button_3',
  },
  DEBT_PAYMENT_CLICK_CREDITCARDPAY: {
    category: 'debit_payment_business',
    eventType: 'click_10',
    eventParams: 'button_10',
  },
  DEBT_PAYMENT_CLICK_CONTACTUS: {
    category: 'debit_payment_business',
    eventType: 'click_15',
    eventParams: 'button_15',
  },
  DEBT_PAYMENT_SHOW_COMPANYLIST: {
    category: 'debit_payment_business',
    eventType: 'visibility_3',
    eventParams: [],
  },
  DEBT_PAYMENT_SHOW_COMPANYTYPE: {
    category: 'debit_payment_business',
    eventType: 'visibility_4',
    eventParams: 'element_1',
  },
  DEBT_PAYMENT_SHOW_PERMDENIED: {
    category: 'debit_payment_business',
    eventType: 'visibility_5',
    eventParams: 'element_2',
  },
  DEBT_PAYMENT_CLICK_PERMDENIED: {
    category: 'debit_payment_business',
    eventType: 'click_2',
    eventParams: 'button_2',
  },
  DEBT_PAYMENT_SHOW_DEBTLIST: {
    category: 'debit_payment_business',
    eventType: 'visibility_6',
    eventParams: [],
  },
  DEBT_PAYMENT_CLICK_DEBTLIST: {
    category: 'debit_payment_business',
    eventType: 'click_4',
    eventParams: 'button_4',
  },
  DEBT_PAYMENT_SHOW_BILLERROR: {
    category: 'debit_payment_business',
    eventType: 'visibility_7',
    eventParams: 'screen_3',
  },
  DEBT_PAYMENT_CLICK_BILLERROR: {
    category: 'debit_payment_business',
    eventType: 'click_5',
    eventParams: 'button_5',
  },
  DEBT_PAYMENT_SHOW_GENERALERROR: {
    category: 'debit_payment_business',
    eventType: 'visibility_8',
    eventParams: 'screen_4',
  },
  DEBT_PAYMENT_CLICK_GENERALERROR: {
    category: 'debit_payment_business',
    eventType: 'click_6',
    eventParams: 'button_6',
  },
  DEBT_PAYMENT_SHOW_CREDITCARDPAY: {
    category: 'debit_payment_business',
    eventType: 'visibility_9',
    eventParams: 'screen_5',
  },
  DEBT_PAYMENT_CLICK_CREDITCARDPAY_INFO: {
    category: 'debit_payment_business',
    eventType: 'click_7',
    eventParams: 'button_7',
  },
  DEBT_PAYMENT_CLICK_CREDITCARDPAY_CVV: {
    category: 'debit_payment_business',
    eventType: 'click_8',
    eventParams: 'button_8',
  },
  DEBT_PAYMENT_SHOW_CREDITCARDPAY_PAYMENTS: {
    category: 'debit_payment_business',
    eventType: 'click_8b',
    eventParams: [],
  },
  DEBT_PAYMENT_CLICK_CREDITCARDPAY_EMAIL: {
    category: 'debit_payment_business',
    eventType: 'click_9',
    eventParams: 'button_9',
  },
  DEBT_PAYMENT_SHOW_CREDITCARDPAY_CCERROR: {
    category: 'debit_payment_business',
    eventType: 'visibility_11',
    eventParams: 'element_3',
  },
  DEBT_PAYMENT_SHOW_CREDITCARDPAY_FORMERROR: {
    category: 'debit_payment_business',
    eventType: 'visibility_12',
    eventParams: 'element_4',
  },
  DEBT_PAYMENT_SHOW_PAMENTSUCCESS_NOPMNTMETHODLNK: {
    category: 'debit_payment_business',
    eventType: 'visibility_13',
    eventParams: 'screen_6',
  },
  DEBT_PAYMENT_SHOW_PAMENTSUCCESS_WITHPMNTMETHODLNK: {
    category: 'debit_payment_business',
    eventType: 'visibility_14',
    eventParams: 'screen_7',
  },
  DEBT_PAYMENT_SHOW_PAMENTERROR_NOPMNTMETHODLNK: {
    category: 'debit_payment_business',
    eventType: 'visibility_15',
    eventParams: 'screen_8',
  },
  DEBT_PAYMENT_SHOW_PAMENTERROR_WITHPMNTMETHODLNK: {
    category: 'debit_payment_business',
    eventType: 'visibility_16',
    eventParams: 'screen_9',
  },
  DEBT_PAYMENT_CLICK_PAMENTERROR_DIAL_NOPMNTMETHODLNK: {
    category: 'debit_payment_business',
    eventType: 'click_11',
    eventParams: 'button_11',
  },
  DEBT_PAYMENT_CLICK_PAMENTERROR_CONTACTUS_NOPMNTMETHODLNK: {
    category: 'debit_payment_business',
    eventType: 'click_12',
    eventParams: 'button_12',
  },
  DEBT_PAYMENT_CLICK_PAMENTERROR_DIAL_WITHPMNTMETHODLNK: {
    category: 'debit_payment_business',
    eventType: 'click_13',
    eventParams: 'button_13',
  },
  DEBT_PAYMENT_CLICK_PAMENTERROR_CONTACTUS_WITHPMNTMETHODLNK: {
    category: 'debit_payment_business',
    eventType: 'click_14',
    eventParams: 'button_14',
  },
  DEBT_PAYMENT_SHOW_CONTACTUS: {
    category: 'debit_payment_business',
    eventType: 'visibility_17',
    eventParams: 'screen_10',
  },
  DEBT_PAYMENT_SHOW_CONTACTUSSUCCESS: {
    category: 'debit_payment_business',
    eventType: 'visibility_18',
    eventParams: 'screen_11',
  },
  DEBT_PAYMENT_SHOW_CONTACTUSERROR: {
    category: 'debit_payment_business',
    eventType: 'visibility_19',
    eventParams: 'screen_12',
  },
  PERSONAL_AREA_SHOW_TRACKER: {
    category: 'personal_area_private',
    eventType: 'visibility_1',
    eventParams: [],
  },
  PERSONAL_AREA_SHOW_TRACKER_POPUP: {
    category: 'personal_area_private',
    eventType: 'visibility_2',
    eventParams: [],
  },
  PERSONAL_AREA_CLICK_TRACKER_POPUP: {
    category: 'personal_area_private',
    eventType: 'click_1',
    eventParams: ['popUpType', 'action'],
  },
  PERSONAL_AREA_SHOW_WELCOME: {
    category: 'personal_area_private',
    eventType: 'lobby_entrance',
    eventParams: [],
  },
  CHANGE_PRICE_PLAN_ERROR_USER_HAS_NOT_CELLULAR_PLANS: {
    category: 'Change plan',
    eventType: 'visibility_1',
    eventParams: 'screen_1',
  },
  CHANGE_PRICE_PLAN_EXISTED_SUBSCRIBERS_COUNT: {
    category: 'Change plan',
    eventType: 'visibility_2',
    eventParams: '',
  },
  CHANGE_PRICE_PLAN_CLICK_ON_GET_CURRENT_PLAN: {
    category: 'Change plan',
    eventType: 'clickֹ_1',
    eventParams: 'button_1',
  },
  CHANGE_PRICE_PLAN_POPUP_CURRENT_PLAN_DATA_IS_SHOWN: {
    category: 'Change plan',
    eventType: 'visibility_3',
    eventParams: 'screen_2',
  },
  CHANGE_PRICE_PLAN_CLICK_SELECT_SUBSCRIBER_FOR_CHANGE: {
    category: 'Change plan',
    eventType: 'clickֹ_2',
    eventParams: 'button_2',
  },
  CHANGE_PRICE_PLAN_SELECTING_NEW_PLAN_PAGE: {
    category: 'Change plan',
    eventType: 'visibility_4',
    eventParams: '',
  },
  CHANGE_PRICE_PLAN_CLICK_SELECT_NEW_PLAN: {
    category: 'Change plan',
    eventType: 'clickֹ_3',
    eventParams: 'button_3',
  },
  CHANGE_PRICE_PLAN_CONFIRMATION_CMP: {
    category: 'Change plan',
    eventType: 'visibility_5',
    eventParams: 'screen_3',
  },
  CHANGE_PRICE_PLAN_RESELECT_NEW_PLAN: {
    category: 'Change plan',
    eventType: 'clickֹ_5',
    eventParams: 'button_5',
  },
  CHANGE_PRICE_PLAN_CONTINUE_POPUP_OPENED: {
    category: 'Change plan',
    eventType: 'visibility_6',
    eventParams: 'screen_4',
  },
  CHANGE_PRICE_PLAN_CONTINUE_POPUP_CANCEL_PROCESS_CLICK: {
    category: 'Change plan',
    eventType: 'clickֹ_6',
    eventParams: 'button_6',
  },
  CHANGE_PRICE_PLAN_CONTINUE_POPUP_CONTINUE_PROCESS_CLICK: {
    category: 'Change plan',
    eventType: 'clickֹ_7',
    eventParams: 'button_7',
  },
  CHANGE_PRICE_PLAN_CONTRACT_SENDING_PAGE: {
    category: 'Change plan',
    eventType: 'visibility_7',
    eventParams: 'screen_5',
  },
  CHANGE_PRICE_PLAN_SEND_CONTRACT_MAIL: {
    category: 'Change plan',
    eventType: 'clickֹ_8',
    eventParams: 'button_8',
  },
  CHANGE_PRICE_PLAN_SEND_CONTRACT_SMS: {
    category: 'Change plan',
    eventType: 'clickֹ_9',
    eventParams: 'button_9',
  },
  CHANGE_PRICE_PLAN_CHANGE_SUCCEEDED: {
    category: 'Change plan',
    eventType: 'visibility_8',
    eventParams: 'screen_6',
  },
  CHANGE_PRICE_PLAN_WARNING_PAGE: {
    category: 'Change plan',
    eventType: 'visibility_9',
    eventParams: 'screen_7',
  },
  CHANGE_PRICE_PLAN_WARNING_PAGE_CONTINUE_CLICK: {
    category: 'Change plan',
    eventType: 'clickֹ_10',
    eventParams: 'button_10',
  },
  CHANGE_PRICE_PLAN_WARNING_PAGE_CANCEL_CLICK: {
    category: 'Change plan',
    eventType: 'clickֹ_11',
    eventParams: 'button_11',
  },
  CHANGE_PRICE_PLAN_ACCOUNT_TYPE_ERROR: {
    category: 'Change plan',
    eventType: 'visibility_10',
    eventParams: 'screen_8',
  },
  CHANGE_PRICE_PLAN_BUNDLE_ERROR: {
    category: 'Change plan',
    eventType: 'visibility_13',
    eventParams: 'screen_11',
  },
  CHANGE_PRICE_PLAN_BUNDLE_CALLBACK_REQUEST: {
    category: 'Change plan',
    eventType: 'clickֹ_13',
    eventParams: 'button_13',
  },
  CHANGE_PRICE_PLAN_BUNDLE_CALLBACK_REQUEST_SENT: {
    category: 'Change plan',
    eventType: 'visibility_14',
    eventParams: 'screen_12',
  },
  CHANGE_PRICE_PLAN_BUNDLE_CALLBACK_REQUEST_FAILED: {
    category: 'Change plan',
    eventType: 'visibility_15',
    eventParams: 'screen_13',
  },
  CHANGE_PRICE_PLAN_SUB_STATUS_ERROR: {
    category: 'Change plan',
    eventType: 'visibility_16',
    eventParams: 'screen_14',
  },
  CHANGE_PRICE_PLAN_SUB_STATUS_CALLBACK_REQUEST: {
    category: 'Change plan',
    eventType: 'clickֹ_14',
    eventParams: 'button_14',
  },
  CHANGE_PRICE_PLAN_SUB_STATUS_CALLBACK_REQUEST_SENT: {
    category: 'Change plan',
    eventType: 'visibility_17',
    eventParams: 'screen_15',
  },
  CHANGE_PRICE_PLAN_SUB_STATUS_CALLBACK_REQUEST_FAILED: {
    category: 'Change plan',
    eventType: 'visibility_18',
    eventParams: 'screen_16',
  },
  CHANGE_PRICE_PLAN_SUB_MODEM_ERROR: {
    category: 'Change plan',
    eventType: 'visibility_19',
    eventParams: 'screen_17',
  },
  CHANGE_PRICE_PLAN_NP_STATUS_ERROR: {
    category: 'Change plan',
    eventType: 'visibility_22',
    eventParams: 'screen_20',
  },
  CHANGE_PRICE_PLAN_FUTURE_PP_ERROR: {
    category: 'Change plan',
    eventType: 'visibility_25',
    eventParams: 'screen_62',
  },
  CHANGE_PRICE_PLAN_NOT_AVAILABLE_FOR_LIMITED_ERROR: {
    category: 'Change plan',
    eventType: 'visibility_66',
    eventParams: 'screen_26',
  },
  CHANGE_PRICE_PLAN_NOT_AVAILABLE_FOR_LIMITED_CALLBACK_REQUEST: {
    category: 'Change plan',
    eventType: 'clickֹ_40',
    eventParams: 'button_40',
  },
  CHANGE_PRICE_PLAN_NOT_AVAILABLE_FOR_LIMITED_CALLBACK_REQUEST_SENT: {
    category: 'Change plan',
    eventType: 'visibility_67',
    eventParams: 'screen_63',
  },
  CHANGE_PRICE_PLAN_NOT_AVAILABLE_FOR_LIMITED_CALLBACK_REQUEST_FAILED: {
    category: 'Change plan',
    eventType: 'visibility_68',
    eventParams: 'screen_64',
  },
  CHANGE_PRICE_PLAN_ERROR_ON_CHANGE: {
    category: 'Change plan',
    eventType: 'visibility_31',
    eventParams: 'screen_29',
  },
  CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_CALLBACK_REQUEST: {
    category: 'Change plan',
    eventType: 'clickֹ_19',
    eventParams: 'button_19',
  },
  CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_CALLBACK_REQUEST_SENT: {
    category: 'Change plan',
    eventType: 'visibility_32',
    eventParams: 'screen_30',
  },
  CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_CALLBACK_REQUEST_FAILED: {
    category: 'Change plan',
    eventType: 'visibility_33',
    eventParams: 'screen_31',
  },
  CHANGE_PRICE_PLAN_THE_SANE_PLAN_ERROR: {
    category: 'Change plan',
    eventType: 'visibility_37',
    eventParams: 'screen_35',
  },
  CHANGE_PRICE_PLAN_SELECT_FOR_LIMITED_Y_PAGE: {
    category: 'Change plan',
    eventType: 'visibility_40',
    eventParams: '',
  },
  CHANGE_PRICE_PLAN_CLICK_ON_GET_CURRENT_PLAN_FOR_LIMITED_Y: {
    category: 'Change plan',
    eventType: 'clickֹ_22',
    eventParams: 'button_22',
  },
  CHANGE_PRICE_PLAN_OPEN_PLANS_PAGE_FOR_LIMITED: {
    category: 'Change plan',
    eventType: 'clickֹ_23',
    eventParams: 'button_23',
  },
  CHANGE_PRICE_PLAN_CLICK_ORDER_BTN_FOR_LIMITED: {
    category: 'Change plan',
    eventType: 'clickֹ_24',
    eventParams: 'button_24',
  },
  CHANGE_PRICE_PLAN_SELECTING_NEW_PLAN_PAGE_FOR_LIMITED: {
    category: 'Change plan',
    eventType: 'visibility_42',
    eventParams: '',
  },
  CHANGE_PRICE_PLAN_RESELECT_NEW_PLAN_FOR_LIMITED: {
    category: 'Change plan',
    eventType: 'clickֹ_28',
    eventParams: 'button_28',
  },
  CHANGE_PRICE_PLAN_CONTINUE_POPUP_OPENED_FOR_LIMITED: {
    category: 'Change plan',
    eventType: 'visibility_45',
    eventParams: 'screen_41',
  },
  CHANGE_PRICE_PLAN_CONTINUE_POPUP_CANCEL_PROCESS_CLICK_FOR_LIMITED: {
    category: 'Change plan',
    eventType: 'clickֹ_30',
    eventParams: 'button_30',
  },
  CHANGE_PRICE_PLAN_CONTINUE_POPUP_CONTINUE_PROCESS_CLICK_FOR_LIMITED: {
    category: 'Change plan',
    eventType: 'clickֹ_31',
    eventParams: 'button_31',
  },
  CHANGE_PRICE_PLAN_CONTRACT_SENDING_PAGE_FOR_LIMITED: {
    category: 'Change plan',
    eventType: 'visibility_46',
    eventParams: 'screen_42',
  },
  CHANGE_PRICE_PLAN_SEND_CONTRACT_MAIL_FOR_LIMITED: {
    category: 'Change plan',
    eventType: 'clickֹ_32',
    eventParams: 'button_32',
  },
  CHANGE_PRICE_PLAN_SEND_CONTRACT_SMS_FOR_LIMITED: {
    category: 'Change plan',
    eventType: 'clickֹ_33',
    eventParams: 'button_33',
  },
  CHANGE_PRICE_PLAN_CHANGE_SUCCEEDED_FOR_LIMITED: {
    category: 'Change plan',
    eventType: 'visibility_47',
    eventParams: 'screen_43',
  },
  CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_FOR_LIMITED: {
    category: 'Change plan',
    eventType: 'visibility_69',
    eventParams: 'screen_65',
  },
  CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_CALLBACK_REQUEST_FOR_LIMITED: {
    category: 'Change plan',
    eventType: 'clickֹ_41',
    eventParams: 'button_41',
  },
  CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_CALLBACK_REQUEST_SENT_FOR_LIMITED: {
    category: 'Change plan',
    eventType: 'visibility_70',
    eventParams: 'screen_66',
  },
  CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_CALLBACK_REQUEST_FAILED_FOR_LIMITED: {
    category: 'Change plan',
    eventType: 'visibility_71',
    eventParams: 'screen_67',
  },
  CHANGE_PRICE_PLAN_ERROR_FAILED_PART_OF_FOR_LIMITED: {
    category: 'Change plan',
    eventType: 'visibility_78',
    eventParams: 'screen_74',
  },
  CHANGE_PRICE_PLAN_SERVER_ERROR: {
    category: 'Change plan',
    eventType: 'visibility_81',
    eventParams: 'screen_77',
  },
  CHANGE_PRICE_PLAN_CLICK_TO_DISABLED_BTN: {
    category: 'Change plan',
    eventType: 'click_45',
    eventParams: 'button_45',
  },
  CHANGE_PRICE_PLAN_CLICK_OPEN_TERMS_CELLULAR_BLOCK: {
    category: 'Change plan',
    eventType: 'click_4',
    eventParams: 'button_4',
  },
  CHANGE_PRICE_PLAN_CLICK_OPEN_TERMS_CELLULAR_BLOCK_FOR_LIMITED: {
    category: 'Change plan',
    eventType: 'click_25',
    eventParams: 'button_25',
  },
  CHANGE_PRICE_PLAN_CLICK_PLAN_TERMS: {
    category: 'Change plan',
    eventType: 'click_4a',
    eventParams: 'button_4a',
  },
  CHANGE_PRICE_PLAN_CLICK_PLAN_TERMS_FOR_LIMITED: {
    category: 'Change plan',
    eventType: 'click_28a',
    eventParams: 'button_28a',
  },

  // Mobility
  MOBILITY_SIM_INIT: {
    category: 'mobility',
    eventType: 'visibility_1',
    eventParams: 'screen_1',
  },
  MOBILITY_SIM_OTP: {
    category: 'mobility',
    eventType: 'visibility_2',
    eventParams: 'screen_2',
  },
  MOBILITY_SIM_OTP_ERROR: {
    category: 'mobility',
    eventType: 'visibility_17',
    eventParams: 'screen_17',
  },
  MOBILITY_SIM_ENVELOPE_CODE: {
    category: 'mobility',
    eventType: 'visibility_3',
    eventParams: 'screen_3',
  },
  MOBILITY_SIM_ACTIVATION_START: {
    category: 'mobility',
    eventType: 'visibility_4',
    eventParams: 'screen_4',
  },
  MOBILITY_SIM_ACTIVATION_SUCSESS: {
    category: 'mobility',
    eventType: 'visibility_5',
    eventParams: 'screen_5',
  },
  MOBILITY_SIM_ACTIVATION_SUCSESS_NO_TIME: {
    category: 'mobility',
    eventType: 'visibility_6',
    eventParams: 'screen_6',
  },
  MOBILITY_SIM_ACTIVATION_FAILURE: {
    category: 'mobility',
    eventType: 'visibility_21',
    eventParams: 'screen_21',
  },
  MOBILITY_SIM_ACTIVATION_IN_PROGRESS: {
    category: 'mobility',
    eventType: 'visibility_10',
    eventParams: 'screen_10',
  },
  MOBILITY_SIM_ACTIVATION_FINISHED: {
    category: 'mobility',
    eventType: 'visibility_16',
    eventParams: 'screen_16',
  },
  MOBILITY_SIM_ACTIVATION_UNABLE: {
    category: 'mobility',
    eventType: 'visibility_29',
    eventParams: 'screen_29',
  },
  // invoice_viewing_process
  INVOICE_VIEWING_INIT: {
    category: 'invoice_viewing_process',
    eventType: 'visibility_1',
    eventParams: 'screen_1',
  },
  INVOICE_VIEWING_CLICK_SELECT: {
    category: 'invoice_viewing_process',
    eventType: 'clickֹ_2',
    eventParams: [],
  },
  INVOICE_VIEWING_SEARCH_APPEAR: {
    category: 'invoice_viewing_process',
    eventType: 'visibility_2',
    eventParams: 'screen_2',
  },
  INVOICE_VIEWING_CLICK_SEARCH_CELLCOM: {
    category: 'invoice_viewing_process',
    eventType: 'click_3',
    eventParams: 'button_1',
  },
  INVOICE_VIEWING_CLICK_SEARCH_NETVISION: {
    category: 'invoice_viewing_process',
    eventType: 'click_4',
    eventParams: 'button_2',
  },
  INVOICE_VIEWING_CLICK_SEARCH_BOTH: {
    category: 'invoice_viewing_process',
    eventType: 'click_21a',
    eventParams: 'button_18a',
  },
  INVOICE_VIEWING_CLICK_SEARCH_MONTH_1: {
    category: 'invoice_viewing_process',
    eventType: 'click_5',
    eventParams: 'button_3',
  },
  INVOICE_VIEWING_CLICK_SEARCH_MONTH_3: {
    category: 'invoice_viewing_process',
    eventType: 'click_6',
    eventParams: 'button_4',
  },
  INVOICE_VIEWING_CLICK_SEARCH_MONTH_6: {
    category: 'invoice_viewing_process',
    eventType: 'click_7',
    eventParams: 'button_5',
  },
  INVOICE_VIEWING_CLICK_SEARCH_MONTH_12: {
    category: 'invoice_viewing_process',
    eventType: 'click_8',
    eventParams: 'button_6',
  },
  INVOICE_VIEWING_CLICK_SEARCH_MONTH_24: {
    category: 'invoice_viewing_process',
    eventType: 'click_9',
    eventParams: 'button_7',
  },
  INVOICE_VIEWING_CLICK_SEARCH_MONTH_36: {
    category: 'invoice_viewing_process',
    eventType: 'click_10',
    eventParams: 'button_8',
  },
  INVOICE_VIEWING_CLICK_SEARCH_FILTER_PSID: {
    category: 'invoice_viewing_process',
    eventType: 'click_11',
    eventParams: 'button_9',
  },
  INVOICE_VIEWING_CLICK_SEARCH_FILTER_SUBSCRIBER: {
    category: 'invoice_viewing_process',
    eventType: 'click_12',
    eventParams: 'button_10',
  },
  INVOICE_VIEWING_CLICK_SEARCH: {
    category: 'invoice_viewing_process',
    eventType: 'click_13',
    eventParams: 'button_11',
  },
  INVOICE_VIEWING_CLICK_SEARCH_RESULTS: {
    category: 'invoice_viewing_process',
    eventType: 'click_14',
    eventParams: 'button_11',
  },
  INVOICE_VIEWING_SEARCH_NOT_VALID: {
    category: 'invoice_viewing_process',
    eventType: 'visibility_4',
    eventParams: 'screen_4',
  },
  INVOICE_VIEWING_SEARCH_EMPTY: {
    category: 'invoice_viewing_process',
    eventType: 'visibility_5',
    eventParams: 'screen_5',
  },
  INVOICE_VIEWING_SEARCH_RESULTS_TIMEOUT: {
    category: 'invoice_viewing_process',
    eventType: 'visibility_6',
    eventParams: 'screen_6',
  },
  INVOICE_VIEWING_SEARCH_RESULTS: {
    category: 'invoice_viewing_process',
    eventType: 'visibility_7',
    eventParams: 'screen_7',
  },
  INVOICE_VIEWING_CLICK_HELP: {
    category: 'invoice_viewing_process',
    eventType: 'click_15',
    eventParams: 'button_12',
  },
  INVOICE_VIEWING_CLICK_HELP_EXPAND: {
    category: 'invoice_viewing_process',
    eventType: 'click_16',
    eventParams: 'button_13',
  },
  INVOICE_VIEWING_CLICK_HELP_CALL: {
    category: 'invoice_viewing_process',
    eventType: 'click_17',
    eventParams: 'button_14',
  },
  INVOICE_VIEWING_CLICK_SORT_INVOICENUMBER: {
    category: 'invoice_viewing_process',
    eventType: 'click_18',
    eventParams: 'button_15',
  },
  INVOICE_VIEWING_CLICK_SORT_PAYMENTDATE: {
    category: 'invoice_viewing_process',
    eventType: 'click_19',
    eventParams: 'button_16',
  },
  INVOICE_VIEWING_CLICK_SORT_AMOUNT: {
    category: 'invoice_viewing_process',
    eventType: 'click_20',
    eventParams: 'button_17',
  },
  INVOICE_VIEWING_CLICK_SORT_ASC: {
    category: 'invoice_viewing_process',
    eventType: 'click_20a',
    eventParams: 'button_17a',
  },
  INVOICE_VIEWING_CLICK_SORT_DESC: {
    category: 'invoice_viewing_process',
    eventType: 'click_20b',
    eventParams: 'button_17b',
  },
  INVOICE_VIEWING_SEARCH_COLLAPSE: {
    category: 'invoice_viewing_process',
    eventType: 'click_14b',
    eventParams: 'button_11b',
  },
  INVOICE_VIEWING_SEARCH_EXPAND: {
    category: 'invoice_viewing_process',
    eventType: 'click_14a',
    eventParams: 'button_11a',
  },
  INVOICE_VIEWING_CLICK_OPEN_PDF: {
    category: 'invoice_viewing_process',
    eventType: 'click_21',
    eventParams: 'button_18',
  },
  INVOICE_VIEWING_OPEN_PDF_SUCCESS: {
    category: 'invoice_viewing_process',
    eventType: 'visibility_8',
    eventParams: [],
  },
  INVOICE_VIEWING_CLICK_SEND_INVOICES: {
    category: 'invoice_viewing_process',
    eventType: 'click_22',
    eventParams: [],
  },
  INVOICE_VIEWING_SEND_INVOICES_NOT_VALID: {
    category: 'invoice_viewing_process',
    eventType: 'visibility_9',
    eventParams: 'screen_8',
  },
  INVOICE_VIEWING_CLICK_SEND_INVOICES_PDF: {
    category: 'invoice_viewing_process',
    eventType: 'click_23',
    eventParams: 'button_19',
  },
  INVOICE_VIEWING_EMAIL_POPUP: {
    category: 'invoice_viewing_process',
    eventType: 'visibility_10',
    eventParams: 'screen_9',
  },
  INVOICE_VIEWING_CLICK_EMAIL_POPUP_SEND: {
    category: 'invoice_viewing_process',
    eventType: 'click_25',
    eventParams: [],
  },
  INVOICE_VIEWING_EMAIL_POPUP_SUCCESS: {
    category: 'invoice_viewing_process',
    eventType: 'visibility_11',
    eventParams: 'screen_10',
  },
  INVOICE_VIEWING_EMAIL_POPUP_FAILURE: {
    category: 'invoice_viewing_process',
    eventType: 'visibility_12',
    eventParams: 'screen_11',
  },

  // Deliveries Update
  DELIVERY_SLOT_START: {
    category: 'Delivery',
    eventType: 'click_1',
    eventParams: 'button_1',
  },
  DELIVERY_SLOT_QUANTITY: {
    category: 'Delivery',
    eventType: 'visibility_1',
    eventParams: [],
  },
  DELIVERY_CANCEL_CLICK: {
    category: 'Delivery',
    eventType: 'click_3',
    eventParams: 'button_3',
  },
  DELIVERY_SHOW_CANCEL_POPUP: {
    category: 'Delivery',
    eventType: 'visibility_2',
    eventParams: 'screen_2',
  },
  DELIVERY_CANCEL_REJECT: {
    category: 'Delivery',
    eventType: 'click_4',
    eventParams: 'button_4',
  },
  DELIVERY_CANCEL_APPROVE: {
    category: 'Delivery',
    eventType: 'visibility_3',
    eventParams: 'screen_3',
  },
  DELIVERY_UPDATE_CLICK: {
    category: 'Delivery',
    eventType: 'click_5',
    eventParams: 'button_5',
  },
  DELIVERY_UPDATE_SUCCESS: {
    category: 'Delivery',
    eventType: 'visibility_4',
    eventParams: 'screen_4',
  },
  DELIVERY_UPDATE_FAIL: {
    category: 'Delivery',
    eventType: 'visibility_5',
    eventParams: 'screen_5',
  },
  DELIVERY_CALENDAR_ADD: {
    category: 'Delivery',
    eventType: 'click_8',
    eventParams: 'button_8',
  },
  DELIVERY_NOT_FOUND: {
    category: 'Delivery',
    eventType: 'visibility_9',
    eventParams: 'screen_9',
  },
  DELIVERY_CALL_SUPPORT: {
    category: 'Delivery',
    eventType: 'click_6',
    eventParams: 'button_6',
  },
  UPDATE_PAYMENT_METHOD_SHOW: {
    category: 'update_payment_business',
    eventType: 'visibility_1',
    eventParams: [],
  },
  UPDATE_PAYMENT_METHOD_CLICK_BUTTON: {
    category: 'update_payment_business',
    eventType: 'click_1',
    eventParams: [],
  },
  UPDATE_PAYMENT_METHOD_SHOW_CHOOSE_ORGID: {
    category: 'update_payment_business',
    eventType: 'visibility_2',
    eventParams: [],
  },
  UPDATE_PAYMENT_METHOD_SHOW_COMPANYTYPE: {
    category: 'update_payment_business',
    eventType: 'visibility_3',
    eventParams: 'cellcom/netvision',
  },
  UPDATE_PAYMENT_METHOD_SELECTED_COMPANYTYPE: {
    category: 'update_payment_business',
    eventType: 'click_7',
    eventParams: '',
  },
  UPDATE_PAYMENT_METHOD_SHOW_NO_PERM: {
    category: 'update_payment_business',
    eventType: 'visibility_4',
    eventParams: 'screen_1',
  },
  UPDATE_PAYMENT_METHOD_SHOW_NUM_OF_METHOD_OPTIONS: {
    category: 'update_payment_business',
    eventType: 'visibility_5',
    eventParams: [],
  },
  UPDATE_PAYMENT_METHOD_SHOW_NUM_OF_ORGS_NOPAYMENT: {
    category: 'update_payment_business',
    eventType: 'visibility_6',
    eventParams: [],
  },
  UPDATE_PAYMENT_METHOD_CLICK_NUM_OF_METHOD_OPTIONS: {
    category: 'update_payment_business',
    eventType: 'click_2',
    eventParams: [],
  },
  UPDATE_PAYMENT_METHOD_CLICK_SEARCH: {
    category: 'update_payment_business',
    eventType: 'click_3',
    eventParams: 'button_1',
  },
  UPDATE_PAYMENT_METHOD_CLICK_NUM_OF_ORGS_CHOSEN: {
    category: 'update_payment_business',
    eventType: 'click_4',
    eventParams: [],
  },
  UPDATE_PAYMENT_METHOD_CLICK_CHOSEN_PAYMENTMETHOD: {
    category: 'update_payment_business',
    eventType: 'click_5',
    eventParams: [],
  },
  UPDATE_PAYMENT_METHOD_SHOW_CREDITCARDPAY_CCERROR: {
    category: 'update_payment_business',
    eventType: 'visibility_7',
    eventParams: [],
  },
  UPDATE_PAYMENT_METHOD_SHOW_CREDITCARDPAY_FORMERROR: {
    category: 'update_payment_business',
    eventType: 'visibility_8',
    eventParams: 'screen_3',
  },
  UPDATE_PAYMENT_METHOD_CLICK_UPLOAD_IMAGE: {
    category: 'update_payment_business',
    eventType: 'click_6',
    eventParams: [],
  },
  UPDATE_PAYMENT_METHOD_SHOW_FORM_ERROR: {
    category: 'update_payment_business',
    eventType: 'visibility_9',
    eventParams: 'screen_4',
  },
  // Private User Flow Update Payemnt
  UPDATE_PRIVATE_PAYMENT_SHOW_STARTING_PAGE: {
    category: 'update_payment_private',
    eventType: 'visibility_1',
    eventParams: '',
  },
  UPDATE_PRIVATE_PAYMENT_CLICK_ON_CHECKBOX_PAYMENT: {
    category: 'update_payment_private',
    eventType: 'click_1',
    eventParams: '',
  },
  UPDATE_PRIVATE_PAYMENT_CLICK_ON_TOOLTIP_CHECKBOX_PAYMENT: {
    category: 'update_payment_private',
    eventType: 'click_2',
    eventParams: '',
  },
  UPDATE_PRIVATE_PAYMENT_CLICK_FORWARD_WITH_UPDATE: {
    category: 'update_payment_private',
    eventType: 'click_3',
    eventParams: 'element_1',
  },
  UPDATE_PRIVATE_PAYMENT_POPUP_BANS_INFORMATION_IS_OPEN: {
    category: 'update_payment_private',
    eventType: 'visibility_3',
    eventParams: 'element_4',
  },

  UPDATE_PRIVATE_PAYMENT_GENERAL_ERROR_PRIVATE: {
    category: 'update_payment_private',
    eventType: 'visibility_2',
    eventParams: 'element_2',
  },
  UPDATE_PRIVATE_PAYMENT_GENERAL_ERROR_CALL_BACK_CLICK_PRIVATE: {
     category: 'update_payment_private',
    eventType: 'click_4',
    eventParams: 'element_3',
  },
  UPDATE_PRIVATE_PAYMENT_SELECTING_BANS_IS_OPEN: {
    category: 'update_payment_private',
    eventType: 'click_2',
    eventParams: '',
  },
  UPDATE_PRIVATE_PAYMENT_CLICK_OKAY_AT_POP_UP_OF_BAN_OPTIONS: {
    category: 'update_payment_private',
    eventType: 'click_5',
    eventParams: 'element_5',
  },
  UPDATE_PRIVATE_PAYMENT_DISPLAY_CC_INPUT_PAGE: {
    category: 'update_payment_private',
    eventType: 'visibility_6',
    eventParams: 'element_7',
  },
  UPDATE_PRIVATE_PAYMENT_CLICK_GO_BACK_TO_CHOOSE_UPDATE_OPTIONS: {
    category: 'update_payment_private',
    eventType: 'click_7',
    eventParams: 'element_8',
  },
  UPDATE_PRIVATE_PAYMENT_CLICK_UPDATE_BTN: {
    category: 'update_payment_private',
    eventType: 'click_8',
    eventParams: 'element_9',
  },
  UPDATE_PRIVATE_PAYMENT_DISPLAY_BAN_NOT_RELATED_TO_CC_ID_POPUP: {
    category: 'update_payment_private',
    eventType: 'visibility_8',
    eventParams: 'element_11',
  },
  UPDATE_PRIVATE_PAYMENT_DISPLAY_CC_BLACKLIST_POPUP: {
    category: 'update_payment_private',
    eventType: 'visibility_9',
    eventParams: 'element_12',
  },
  UPDATE_PRIVATE_PAYMENT_ALL_FAILED_UPDATES_PAGE: {
    category: 'update_payment_private',
    eventType: 'visibility_11',
    eventParams: 'element_16',
  },
  UPDATE_PRIVATE_PAYMENT_FAILED_UPDATES_PAGE_ACCOUNT_HAS_DEBT: {
    category: 'update_payment_private',
    eventType: 'visibility_10',
    eventParams: 'element_13',
  },
  UPDATE_PRIVATE_PAYMENT_FAILED_UPDATES_PAGE_ACCOUNT_HAS_DEBT_CALLBACK_CLICK: {
    category: 'update_payment_private',
    eventType: 'click_9',
    eventParams: 'element_14',
  },
  UPDATE_PRIVATE_PAYMENT_FAILED_UPDATES_HAS_DEBT_CLICK_TRY_AGAIN: {
    category: 'update_payment_private',
    eventType: 'click_10',
    eventParams: 'element_15',
  },
  UPDATE_PRIVATE_PAYMENT_ALL_FAILED_UPDATES_CALLBACK_CLICK: {
    category: 'update_payment_private',
    eventType: 'click_11',
    eventParams: 'element_17',
  },
  UPDATE_PRIVATE_PAYMENT_ALL_FAILED_UPDATES_CLICK_TRY_AGAIN:{
    category: 'update_payment_private',
    eventType: 'click_12',
    eventParams: 'element_18',
  },
  UPDATE_PRIVATE_PAYMENT_ALL_OK_UPDATES_PAGE: {
    category: 'update_payment_private',
    eventType: 'visibility_7',
    eventParams: 'element_10',
  },
  UPDATE_PRIVATE_PAYMENT_PARTIALLY_OK_UPDATES_PAGE: {
    category: 'update_payment_private',
    eventType: 'visibility_12',
    eventParams: 'element_19',
  },
  UPDATE_PRIVATE_PAYMENT_PARTIALLY_FAILED_UPDATES_CALLBACK_CLICK: {
    category: 'update_payment_private',
    eventType: 'click_13',
    eventParams: 'element_20',
  },
  UPDATE_PRIVATE_PAYMENT_PARTIALLY_FAILED_UPDATES_TRY_AGAIN_CLICK: {
    category: 'update_payment_private',
    eventType: 'click_14',
    eventParams: 'element_21',
  },
  //Cellcom abroad
  ABROAD_LOBBY_IS_LOADED: {
    event: 'CellcomAbroad_Step1_LobbyPage',
    step: '1',
    action: 'LobbyPage',
    process_type: 'private',
    category: 'hul_sale_private',
    eventType: 'visibility_1',
    funnel_name: '1 - Lobby',
    eventParams: [],
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_IS_CLICKED_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_1',
    eventParams: 'element_1',
  },
  ABROAD_LOBBY_SELECT_DATES_TAB_IS_CLICKED_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_2',
    eventParams: 'element_2',
  },
  ABROAD_LOBBY_SEARCH_PACKAGES_BUTTON_IS_CLICKED_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_3',
    eventParams: 'element_3',
  },
  ABROAD_LOBBY_POPULAR_ARE_SHOWN_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'visibility_2',
    eventParams: 'element_4',
  },
  ABROAD_LOBBY_POPULAR_PURCHASE_PACKAGE_BUTTON_IS_CLICKED_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_4',
    eventParams: [],
  },
  ABROAD_LOBBY_POPULAR_SHOW_SUPPORTED_COUNTRIES_BUTTON_IS_CLICKED_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_5',
    eventParams: 'element_5',
  },
  ABROAD_LOBBY_POPULAR_IMPORTANT_TO_KNOW_BUTTON_IS_CLICKED_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_6',
    eventParams: 'element_6',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_IS_OPENED_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'visibility_3',
    eventParams: 'element_7',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_REMOVE_SEARCH_VALUE_FROM_INPUT_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_7',
    eventParams: 'element_8',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_SELECT_POPULAR_COUNTRY_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_8',
    eventParams: [],
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_SELECT_SEARCHED_COUNTRY_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_9',
    eventParams: [],
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_CONTINUE_BUTTON_IS_CLICKED_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_10',
    eventParams: [],
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_CONNECTED_COUNTRY_EXISTS_POPUP_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'visibility_4',
    eventParams: 'element_9',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ADD_COUNTRY_FROM_CONNECTED_COUNTRY_EXISTS_POPUP_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_11',
    eventParams: 'element_10',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_LIMITED_COUNTRY_COUNT_POPUP_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'visibility_5',
    eventParams: 'element_11',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ERROR_ON_SEARCH_COUNTRY_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'visibility_6',
    eventParams: [],
  },
  ABROAD_LOBBY_SELECT_DATES_TAB_IS_OPENED_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'visibility_7',
    eventParams: 'element_12',
  },
  ABROAD_LOBBY_SELECT_DATES_TAB_START_DATE_IS_SELECTED_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_12',
    eventParams: 'element_13',
  },
  ABROAD_LOBBY_SELECT_DATES_TAB_END_DATE_IS_SELECTED_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_13',
    eventParams: [],
  },
  ABROAD_LOBBY_SEARCHED_PACKAGES_ARE_SHOWN_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'visibility_8',
    eventParams: [],
  },
  ABROAD_LOBBY_SHOW_MORE_PACKAGES_BUTTON_CLICK_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_14',
    eventParams: 'element_14',
  },

  
  ABROAD_LOBBY_NOT_EXACT_PACKAGES_ARE_SHOWN_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'visibility_9',
    eventParams: [],
  },
  ABROAD_LOBBY_SEARCHED_PURCHASE_BUTTON_IS_CLICKED_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_16',
    eventParams: 'element_16',
  },
  ABROAD_LOBBY_SEARCHED_SHOW_SUPPORTED_COUNTRIES_BUTTON_IS_CLICKED_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_17',
    eventParams: 'element_17',
  },
  ABROAD_LOBBY_SEARCHED_IMPORTANT_TO_KNOW_BUTTON_IS_CLICKED_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_18',
    eventParams: 'element_18',
  },
  ABROAD_TICKET_IS_SHOWN_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'visibility_15',
    eventParams: [],
  },
  ABROAD_TICKET_PACKAGE_BY_USE_PRICES_DATA_IS_OPENED_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'visibility_16',
    eventParams: 'element_19',
  },
  ABROAD_TICKET_PACKAGE_BY_USE_SHOW_PRICES_BUTTON_CLICK_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_24',
    eventParams: 'element_20',
  },
  ABROAD_TICKET_CHANGE_START_DATE_BUTTON_CLICK_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_25',
    eventParams: 'element_21',
  },
  ABROAD_TICKET_START_DATE_IS_CHANGED_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_26',
    eventParams: 'element_22',
  },
  ABROAD_TICKET_TOOLTIP_IS_OPENED_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_27',
    eventParams: 'element_23',
  },
  ABROAD_TICKET_WARNING_MESSAGE_IS_SHOWN_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'visibility_17',
    eventParams: [],
  },
  ABROAD_TICKET_OTP_SEND_CODE_BUTTON_CLICK_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_28',
    eventParams: 'element_24',
  },
  ABROAD_TICKET_OTP_VALIDATED_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'visibility_18',
    eventParams: 'element_25',
  },
  ABROAD_TICKET_OTP_VALIDATION_ERROR_ACCOUNT_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'visibility_19',
    eventParams: [],
  },
  ABROAD_TICKET_OTP_VALIDATION_IS_BUSINESS_ACCOUNT_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'visibility_20',
    eventParams: 'element_26',
  },
  ABROAD_TICKET_OTP_VALIDATION_IS_BUSINESS_ACCOUNT_BUTTON_ACTION_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_29',
    eventParams: [],
  },
  ABROAD_TICKET_OTP_VALIDATION_IS_CELLCOM_WORKER_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'visibility_21',
    eventParams: 'element_27',
  },
  ABROAD_TICKET_OTP_VALIDATION_IS_CELLCOM_WORKER_BUTTON_ACTION_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_30',
    eventParams: [],
  },
  ABROAD_TICKET_DEFAULT_PACKAGE_POPUP_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'visibility_22',
    eventParams: 'element_28',
  },
  ABROAD_TICKET_DEFAULT_PACKAGE_POPUP_WITH_WARNING_MESSAGE_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'visibility_23',
    eventParams: 'element_29',
  },
  ABROAD_TICKET_DEFAULT_PACKAGE_POPUP_BUTTON_ACTION_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_31',
    eventParams: [],
  },
  ABROAD_TICKET_CHECKBOX_SELECTED_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_32',
    eventParams: 'element_30',
  },
  ABROAD_TICKET_OPEN_TERMS_LINK_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_33',
    eventParams: 'element_31',
  },
  ABROAD_TICKET_ADD_PACKAGE_BUTTON_CLICK_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_34',
    eventParams: 'element_32',
  },
  ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'visibility_24',
    eventParams: 'element_33',
  },
  ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_STAY_WITH_BLOCKED_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_35',
    eventParams: 'element_34',
  },
  ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_CANCEL_BLOCKED_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_36',
    eventParams: 'element_35',
  },
  ABROAD_COMPLETED_WITH_SUCCESS_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'visibility_25',
    eventParams: 'element_36',
  },
  ABROAD_COMPLETED_WITH_SUCCESS_PURCHASE_FOR_SOMEBODY_ELSE_CLICK_BUTTON_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_37',
    eventParams: [],
  },
  ABROAD_COMPLETED_WITH_SUCCESS_CLICK_ON_BANNER_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_38',
    eventParams: [],
  },
  ABROAD_COMPLETED_WITH_SUCCESS_GO_TO_MY_ABROAD_DATA_CLICK_PRIVATE: {
    //SPRINT 2
    category: 'hul_sale_private',
    eventType: 'click_39',
    eventParams: 'element_37',
  },
  ABROAD_COMPLETED_WITH_GENERAL_ERROR_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'visibility_26',
    eventParams: 'element_38',
  },
  ABROAD_COMPLETED_WITH_GENERAL_ERROR_CALLBACK_CLICK_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_40',
    eventParams: 'element_39',
  },
  ABROAD_COMPLETED_WITH_GENERAL_ERROR_FINISH_BUTTON_CLICK_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_41',
    eventParams: 'element_40',
  },
  ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'visibility_27',
    eventParams: 'element_41',
  },
  ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_CALLBACK_CLICK_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_42',
    eventParams: 'element_42',
  },
  ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_FINISH_BUTTON_CLICK_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'click_43',
    eventParams: 'element_43',
  },

  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_IS_OPENED_PRIVATE_FROM_PACKAGE: {
    //76
    category: 'hul_sale_private',
    eventType: 'visibility_28',
    eventParams: 'element_44',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_REMOVE_SEARCH_VALUE_FROM_INPUT_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_44',
    eventParams: 'element_45',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_SELECT_POPULAR_COUNTRY_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_45',
    eventParams: [],
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_SELECT_SEARCHED_COUNTRY_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_46',
    eventParams: [],
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_CONTINUE_BUTTON_IS_CLICKED_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_47',
    eventParams: [],
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_CONNECTED_COUNTRY_EXISTS_POPUP_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'visibility_29',
    eventParams: 'element_46',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ADD_COUNTRY_FROM_CONNECTED_COUNTRY_EXISTS_POPUP_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_48',
    eventParams: 'element_47',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_LIMITED_COUNTRY_COUNT_POPUP_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'visibility_30',
    eventParams: 'element_48',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ERROR_ON_SEARCH_COUNTRY_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'visibility_31',
    eventParams: [],
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ALL_COUNTRIES_ARE_UNSUPPORTED_POPUP_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'visibility_32',
    eventParams: 'element_49',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ALL_COUNTRIES_ARE_UNSUPPORTED_POPUP_CONTINUE_TO_DATES_BUTTON_CLICK_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_49',
    eventParams: 'element_50',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ALL_COUNTRIES_ARE_UNSUPPORTED_POPUP_RETURN_TO_COUNTRIES_BUTTON_CLICK_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_50',
    eventParams: 'element_51',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_COUNTRY_IS_UNSUPPORTED_POPUP_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'visibility_33',
    eventParams: 'element_52',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_COUNTRY_IS_UNSUPPORTED_POPUP_SEARCH_PACKAGE_REGARDING_TO_SELECTED_BUTTON_CLICK_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_52',
    eventParams: 'element_54',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_COUNTRY_IS_UNSUPPORTED_POPUP_CONTINUE_WITH_SELECTED_PACKAGE_BUTTON_CLICK_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_53',
    eventParams: 'element_55',
  },
  ABROAD_LOBBY_SELECT_DATES_TAB_IS_OPENED_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'visibility_35',
    eventParams: 'element_56',
  },
  ABROAD_LOBBY_SELECT_DATES_TAB_START_DATE_IS_SELECTED_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_54',
    eventParams: 'element_57',
  },
  ABROAD_LOBBY_SELECT_DATES_TAB_END_DATE_IS_SELECTED_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_55',
    eventParams: [],
  },
  ABROAD_LOBBY_SELECT_DATES_TAB_SELECTED_DURATION_MORE_THAN_PACKAGE_DURATION_POPUP_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'visibility_36',
    eventParams: 'element_58',
  },
  ABROAD_LOBBY_SELECT_DATES_TAB_SELECTED_DURATION_MORE_THAN_PACKAGE_DURATION_POPUP_SEARCH_PACKAGE_REGARDING_TO_SELECTED_PARAMETERS_BUTTON_CLICK_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_57',
    eventParams: 'element_60',
  },
  ABROAD_LOBBY_SELECT_DATES_TAB_SELECTED_DURATION_MORE_THAN_PACKAGE_DURATION_POPUP_CONTINUE_WITH_SELECTED_PACKAGE_BUTTON_CLICK_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_58',
    eventParams: 'element_61',
  },
  ABROAD_TICKET_IS_SHOWN_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'visibility_38',
    eventParams: [],
  },
  ABROAD_TICKET_PACKAGE_BY_USE_PRICES_DATA_IS_OPENED_PRIVATE_FROM_PACKAGE: {
    //NATHANIEL (private 102)
    category: 'hul_sale_private',
    eventType: 'visibility_39',
    eventParams: 'element_62',
  },
  ABROAD_TICKET_PACKAGE_BY_USE_SHOW_PRICES_BUTTON_CLICK_PRIVATE_FROM_PACKAGE: {
    //NATHANIEL (private 103)
    category: 'hul_sale_private',
    eventType: 'click_59',
    eventParams: 'element_63',
  },
  ABROAD_TICKET_CHANGE_START_DATE_BUTTON_CLICK_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_60',
    eventParams: 'element_64',
  },
  ABROAD_TICKET_START_DATE_IS_CHANGED_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_61',
    eventParams: 'element_65',
  },
  ABROAD_TICKET_TOOLTIP_IS_OPENED_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_62',
    eventParams: 'element_66',
  },
  ABROAD_TICKET_WARNING_MESSAGE_IS_SHOWN_PRIVATE_FROM_PACKAGE: {
    //#100 OR #107
    category: 'hul_sale_private',
    eventType: 'visibility_40',
    eventParams: [],
  },
  ABROAD_TICKET_OTP_SEND_CODE_BUTTON_CLICK_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_63',
    eventParams: 'element_67',
  },
  ABROAD_TICKET_OTP_VALIDATED_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'visibility_41',
    eventParams: 'element_68',
  },
  ABROAD_TICKET_OTP_VALIDATION_ERROR_ACCOUNT_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'visibility_42',
    eventParams: [],
  },
  ABROAD_TICKET_OTP_VALIDATION_IS_BUSINESS_ACCOUNT_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'visibility_43',
    eventParams: 'element_69',
  },
  ABROAD_TICKET_OTP_VALIDATION_IS_BUSINESS_ACCOUNT_BUTTON_ACTION_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_64',
    eventParams: [],
  },
  ABROAD_TICKET_OTP_VALIDATION_IS_CELLCOM_WORKER_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'visibility_44',
    eventParams: 'element_70',
  },
  ABROAD_TICKET_OTP_VALIDATION_IS_CELLCOM_WORKER_BUTTON_ACTION_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_65',
    eventParams: [],
  },
  ABROAD_TICKET_DEFAULT_PACKAGE_POPUP_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'visibility_45',
    eventParams: 'element_71',
  },
  ABROAD_TICKET_DEFAULT_PACKAGE_POPUP_WITH_WARNING_MESSAGE_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'visibility_46',
    eventParams: 'element_72',
  },
  ABROAD_TICKET_DEFAULT_PACKAGE_POPUP_BUTTON_ACTION_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_66',
    eventParams: [],
  },
  ABROAD_TICKET_CHECKBOX_SELECTED_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_67',
    eventParams: 'element_73',
  },
  ABROAD_TICKET_OPEN_TERMS_LINK_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_68',
    eventParams: 'element_74',
  },
  ABROAD_TICKET_ADD_PACKAGE_BUTTON_CLICK_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_69',
    eventParams: 'element_75',
  },
  ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'visibility_47',
    eventParams: 'element_76',
  },
  ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_STAY_WITH_BLOCKED_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_70',
    eventParams: 'element_77',
  },
  ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_CANCEL_BLOCKED_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_71',
    eventParams: 'element_78',
  },
  ABROAD_COMPLETED_WITH_SUCCESS_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'visibility_48',
    eventParams: 'element_79',
  },
  ABROAD_COMPLETED_WITH_SUCCESS_PURCHASE_FOR_SOMEBODY_ELSE_CLICK_BUTTON_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_72',
    eventParams: [],
  },
  ABROAD_COMPLETED_WITH_SUCCESS_CLICK_ON_BANNER_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_73',
    eventParams: [],
  },
  ABROAD_COMPLETED_WITH_SUCCESS_GO_TO_MY_ABROAD_DATA_CLICK_PRIVATE_FROM_PACKAGE: {
    //SPRINT 2
    category: 'hul_sale_private',
    eventType: 'click_74',
    eventParams: 'element_80',
  },
  ABROAD_COMPLETED_WITH_GENERAL_ERROR_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'visibility_49',
    eventParams: 'element_81',
  },
  ABROAD_COMPLETED_WITH_GENERAL_ERROR_CALLBACK_CLICK_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_75',
    eventParams: 'element_82',
  },
  ABROAD_COMPLETED_WITH_GENERAL_ERROR_FINISH_BUTTON_CLICK_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_76',
    eventParams: 'element_83',
  },
  ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'visibility_50',
    eventParams: 'element_84',
  },
  ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_CALLBACK_CLICK_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_77',
    eventParams: 'element_85',
  },
  ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_FINISH_BUTTON_CLICK_PRIVATE_FROM_PACKAGE: {
    category: 'hul_sale_private',
    eventType: 'click_78',
    eventParams: 'element_86',
  },
  ABROAD_TICKET_PHONE_VALUE_IS_NOT_VALID_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'visibility_51',
    eventParams: 'element_87',
  },
  ABROAD_TICKET_OTP_STEP_PRIVATE: {
    category: 'hul_sale_private',
    eventType: 'visibility_52',
    eventParams: 'element_882',
  },
  //   //Cellcom abroad business
  ABROAD_LOBBY_OTP_SEND_CODE_BUTTON_CLICK_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_1',
    eventParams: 'element_1',
  },
  ABROAD_LOBBY_OTP_RESEND_CODE_BUTTON_CLICK_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_2',
    eventParams: [],
  },
  ABROAD_LOBBY_OTP_VALIDATE_CODE_BUTTON_CLICK_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_3',
    eventParams: 'element_2',
  },
  ABROAD_LOBBY_OTP_VALIDATION_IS_CELLCOM_WORKER_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'visibility_1',
    eventParams: 'element_3',
  },
  ABROAD_LOBBY_OTP_VALIDATION_IS_CELLCOM_WORKER_THANKS_BUTTON_CLICK_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_4',
    eventParams: 'element_4',
  },
  ABROAD_LOBBY_OTP_VALIDATION_CANT_PURCHASE_POPUP_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'visibility_2',
    eventParams: 'element_5',
  },
  ABROAD_LOBBY_OTP_VALIDATION_CANT_PURCHASE_POPUP_CALLBACK_CLICK_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_5',
    eventParams: 'element_6',
  },
  ABROAD_LOBBY_OTP_VALIDATION_SOC_ROAM_POPUP_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'visibility_3',
    eventParams: 'element_7',
  },
  ABROAD_LOBBY_OTP_VALIDATION_SOC_ROAM_POPUP_CALLBACK_CLICK_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_6',
    eventParams: 'element_8',
  },
  ABROAD_LOBBY_OTP_VALIDATION_AUTO_PACKAGE_POPUP_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'visibility_4',
    eventParams: 'element_9',
  },
  ABROAD_LOBBY_OTP_VALIDATION_AUTO_PACKAGE_POPUP_BUTTON_CLICK_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_7',
    eventParams: 'element_10',
  },
  ABROAD_TICKET_DEFAULT_PACKAGE_POPUP_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'visibility_5',
    eventParams: 'element_11',
  },
  ABROAD_TICKET_DEFAULT_PACKAGE_POPUP_OPEN_EXISTS_PACKAGE_BUTTON_CLICK_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_8',
    eventParams: 'element_12',
  },
  ABROAD_TICKET_DEFAULT_PACKAGE_POPUP_BUTTON_ACTION_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_9',
    eventParams: [],
  },
  ABROAD_LOBBY_OTP_VALIDATION_ROLLING_PACKAGE_POPUP_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'visibility_6',
    eventParams: 'element_13',
  },
  ABROAD_LOBBY_OTP_VALIDATION_ROLLING_PACKAGE_POPUP_BUTTON_CLICK_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_10',
    eventParams: 'element_14',
  },
  ABROAD_LOBBY_OTP_VALIDATION_IS_PRIVATE_ACCOUNT_POPUP_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'visibility_8',
    eventParams: 'element_17',
  },
  ABROAD_LOBBY_OTP_VALIDATED_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'visibility_9',
    eventParams: 'element_19',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_IS_CLICKED_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_13',
    eventParams: 'element_20',
  },
  ABROAD_LOBBY_SELECT_DATES_TAB_IS_CLICKED_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_14',
    eventParams: 'element_21',
  },
  ABROAD_LOBBY_SEARCH_PACKAGES_BUTTON_IS_CLICKED_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_15',
    eventParams: 'element_22',
  },
  ABROAD_LOBBY_POPULAR_ARE_SHOWN_BUSINESS: {
    //NATHANIEL (BUSINESS 29)
    category: 'hul_sale_business',
    eventType: 'visibility_10',
    eventParams: 'element_23',
  },
  ABROAD_LOBBY_PURCHASE_PACKAGE_BUTTON_IS_CLICKED_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_16',
    eventParams: [],
  },
  ABROAD_LOBBY_POPULAR_SHOW_SUPPORTED_COUNTRIES_BUTTON_IS_CLICKED_BUSINESS: {
    //NATHANIEL (BUSINESS 31)
    category: 'hul_sale_business',
    eventType: 'click_17',
    eventParams: 'element_24',
  },
  ABROAD_LOBBY_POPULAR_IMPORTANT_TO_KNOW_BUTTON_IS_CLICKED_BUSINESS: {
    //NATHANIEL (business 32)
    category: 'hul_sale_business',
    eventType: 'click_18',
    eventParams: 'element_25',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_IS_OPENED_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'visibility_11',
    eventParams: 'element_26',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_REMOVE_SEARCH_VALUE_FROM_INPUT_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_19',
    eventParams: 'element_27',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_SELECT_POPULAR_COUNTRY_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_20',
    eventParams: [],
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_SELECT_SEARCHED_COUNTRY_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_21',
    eventParams: [],
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_CONTINUE_BUTTON_IS_CLICKED_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_22',
    eventParams: [],
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_CONNECTED_COUNTRY_EXISTS_POPUP_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'visibility_12',
    eventParams: 'element_28',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ADD_COUNTRY_FROM_CONNECTED_COUNTRY_EXISTS_POPUP_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_23',
    eventParams: 'element_29',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_LIMITED_COUNTRY_COUNT_POPUP_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'visibility_13',
    eventParams: 'element_30',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ERROR_ON_SEARCH_COUNTRY_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'visibility_14',
    eventParams: [],
  },
  ABROAD_LOBBY_SELECT_DATES_TAB_IS_OPENED_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'visibility_15',
    eventParams: 'element_31',
  },
  ABROAD_LOBBY_SELECT_DATES_TAB_START_DATE_IS_SELECTED_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_24',
    eventParams: 'element_32',
  },
  ABROAD_LOBBY_SELECT_DATES_TAB_END_DATE_IS_SELECTED_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_25',
    eventParams: [],
  },
  ABROAD_LOBBY_SEARCHED_PACKAGES_ARE_SHOWN_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'visibility_16',
    eventParams: [],
  },
  ABROAD_LOBBY_SHOW_MORE_PACKAGES_BUTTON_CLICK_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_26',
    eventParams: 'element_33',
  },
  ABROAD_LOBBY_SHOW_MORE_BUT_NOT_EXACT_PACKAGES_BUTTON_CLICK_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_27',
    eventParams: 'element_34',
  },
  ABROAD_LOBBY_NOT_EXACT_PACKAGES_ARE_SHOWN_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'visibility_17',
    eventParams: [],
  },
  ABROAD_LOBBY_SEARCHED_PURCHASE_BUTTON_IS_CLICKED_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_28',
    eventParams: 'element_35',
  },
  ABROAD_LOBBY_SEARCHED_SHOW_SUPPORTED_COUNTRIES_BUTTON_IS_CLICKED_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_29',
    eventParams: 'element_36',
  },
  ABROAD_LOBBY_SEARCHED_IMPORTANT_TO_KNOW_BUTTON_IS_CLICKED_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_30',
    eventParams: 'element_37',
  },
  ABROAD_TICKET_IS_SHOWN_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'visibility_23',
    eventParams: [],
  },
  ABROAD_TICKET_CHANGE_START_DATE_BUTTON_CLICK_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_36',
    eventParams: 'element_38',
  },
  ABROAD_TICKET_OPEN_TERMS_LINK_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_37',
    eventParams: 'element_39',
  },
  ABROAD_TICKET_ADD_PACKAGE_BUTTON_CLICK_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_38',
    eventParams: 'element_40',
  },
  ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'visibility_24',
    eventParams: 'element_41',
  },
  ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_BUTTON_ACTION_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_39',
    eventParams: [],
  },
  ABROAD_COMPLETED_WITH_SUCCESS_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'visibility_25',
    eventParams: 'element_42',
  },
  ABROAD_COMPLETED_WITH_SUCCESS_CLICK_FINISH_BUTTON_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_40',
    eventParams: 'element_43',
  },
  ABROAD_COMPLETED_WITH_GENERAL_ERROR_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'visibility_26',
    eventParams: 'element_45',
  },
  ABROAD_COMPLETED_WITH_GENERAL_ERROR_CALLBACK_CLICK_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_42',
    eventParams: 'element_46',
  },
  ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'visibility_27',
    eventParams: 'element_47',
  },
  //   //   ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_GO_TO_MY_ABROAD_DATA_CLICK_BUSINESS: { //SPRINT 2
  //   //   category: 'hul_sale_business',
  //   //   eventType: 'click_43',
  //   //   eventParams: 'element_48',
  //   // },
  ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_CALLBACK_CLICK_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_44',
    eventParams: 'element_49',
  },

  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_IS_OPENED_BUSINESS_FROM_PACKAGE: {
    //76
    category: 'hul_sale_business',
    eventType: 'visibility_28',
    eventParams: 'element_50',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_REMOVE_SEARCH_VALUE_FROM_INPUT_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'click_45',
    eventParams: 'element_51',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_SELECT_POPULAR_COUNTRY_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'click_46',
    eventParams: [],
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_SELECT_SEARCHED_COUNTRY_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'click_47',
    eventParams: [],
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_CONTINUE_BUTTON_IS_CLICKED_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'click_48',
    eventParams: [],
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_CONNECTED_COUNTRY_EXISTS_POPUP_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'visibility_29',
    eventParams: 'element_52',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ADD_COUNTRY_FROM_CONNECTED_COUNTRY_EXISTS_POPUP_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'click_49',
    eventParams: 'element_53',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_LIMITED_COUNTRY_COUNT_POPUP_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'visibility_30',
    eventParams: 'element_54',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ERROR_ON_SEARCH_COUNTRY_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'visibility_31',
    eventParams: [],
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ALL_COUNTRIES_ARE_UNSUPPORTED_POPUP_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'visibility_32',
    eventParams: 'element_55',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ALL_COUNTRIES_ARE_UNSUPPORTED_POPUP_CONTINUE_TO_DATES_BUTTON_CLICK_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'click_50',
    eventParams: 'element_56',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ALL_COUNTRIES_ARE_UNSUPPORTED_POPUP_RETURN_TO_COUNTRIES_BUTTON_CLICK_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'click_51',
    eventParams: 'element_57',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_COUNTRY_IS_UNSUPPORTED_POPUP_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'visibility_33',
    eventParams: 'element_58',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_COUNTRY_IS_UNSUPPORTED_POPUP_SEARCH_PACKAGE_REGARDING_TO_SELECTED_BUTTON_CLICK_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'click_53',
    eventParams: 'element_60',
  },
  ABROAD_LOBBY_SELECT_COUNTRIES_TAB_COUNTRY_IS_UNSUPPORTED_POPUP_CONTINUE_WITH_SELECTED_PACKAGE_BUTTON_CLICK_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'click_54',
    eventParams: 'element_61',
  },
  ABROAD_LOBBY_SELECT_DATES_TAB_IS_OPENED_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'visibility_35',
    eventParams: 'element_62',
  },
  ABROAD_LOBBY_SELECT_DATES_TAB_START_DATE_IS_SELECTED_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'click_55',
    eventParams: 'element_63',
  },
  ABROAD_LOBBY_SELECT_DATES_TAB_END_DATE_IS_SELECTED_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'click_56',
    eventParams: [],
  },
  ABROAD_LOBBY_SELECT_DATES_TAB_SELECTED_DURATION_MORE_THAN_PACKAGE_DURATION_POPUP_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'visibility_36',
    eventParams: 'element_64',
  },
  ABROAD_LOBBY_SELECT_DATES_TAB_SELECTED_DURATION_MORE_THAN_PACKAGE_DURATION_POPUP_SEARCH_PACKAGE_REGARDING_TO_SELECTED_PARAMETERS_BUTTON_CLICK_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'click_58',
    eventParams: 'element_66',
  },
  ABROAD_LOBBY_SELECT_DATES_TAB_SELECTED_DURATION_MORE_THAN_PACKAGE_DURATION_POPUP_CONTINUE_WITH_SELECTED_PACKAGE_BUTTON_CLICK_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'click_59',
    eventParams: 'element_67',
  },
  ABROAD_TICKET_IS_SHOWN_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'visibility_37',
    eventParams: [],
  },
  ABROAD_TICKET_CHANGE_START_DATE_BUTTON_CLICK_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'click_60',
    eventParams: 'element_68',
  },
  ABROAD_TICKET_OPEN_TERMS_LINK_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'click_61',
    eventParams: 'element_69',
  },
  ABROAD_TICKET_ADD_PACKAGE_BUTTON_CLICK_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'click_62',
    eventParams: 'element_70',
  },
  ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'visibility_38',
    eventParams: 'element_71',
  },
  ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_BUTTON_ACTION_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'click_63',
    eventParams: [],
  },
  ABROAD_COMPLETED_WITH_SUCCESS_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'visibility_39',
    eventParams: 'element_72',
  },
  ABROAD_COMPLETED_WITH_SUCCESS_CLICK_FINISH_BUTTON_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'click_64',
    eventParams: 'element_73',
  },
  ABROAD_COMPLETED_WITH_SUCCESS_GO_TO_MY_ABROAD_DATA_CLICK_BUSINESS_FROM_PACKAGE: {
    //SPRINT 2
    category: 'hul_sale_business',
    eventType: 'click_65',
    eventParams: 'element_74',
  },
  ABROAD_COMPLETED_WITH_SUCCESS_GO_TO_MY_ABROAD_DATA_CLICK_BUSINESS: {
    //SPRINT 2
    category: 'hul_sale_business',
    eventType: 'click_41',
    eventParams: 'element_44',
  },
  ABROAD_COMPLETED_WITH_FAIL_GO_TO_PACKAGE_BUSINESS: {
    category: 'hul_sale_business',
    eventType: 'click_43',
    eventParams: 'element_48',
  },
  ABROAD_COMPLETED_WITH_FAIL_GO_TO_PACKAGE_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'click_67',
    eventParams: 'element_78',
  },
  ABROAD_COMPLETED_WITH_GENERAL_ERROR_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'visibility_40',
    eventParams: 'element_75',
  },
  ABROAD_COMPLETED_WITH_GENERAL_ERROR_CALLBACK_CLICK_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'click_66',
    eventParams: 'element_76',
  },
  ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'visibility_41',
    eventParams: 'element_77',
  },
  ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_CALLBACK_CLICK_BUSINESS_FROM_PACKAGE: {
    category: 'hul_sale_business',
    eventType: 'visibility_68',
    eventParams: 'element_79',
  },
  ABROAD_BUSINESS_INDIVIDUAL_SELECTED_COMPANY_NOT_ALLOWED: {
    category: 'hul_sale_contacts',
    eventType: 'visibility_1',
    eventParams: 'element_1',
  },
  ABROAD_BUSINESS_INDIVIDUAL_SELECTED_COMPANY_NOT_ALLOWED_CALLBACK_CLICK: {
    category: 'hul_sale_contacts',
    eventType: 'click_1',
    eventParams: 'element_2',
  },
  ABROAD_BUSINESS_INDIVIDUAL_SELECT_COMPANY_COMPONENT_VIEW: {
    category: 'hul_sale_contacts',
    eventType: 'visibility_2',
    eventParams: 'element_3',
  },
  ABROAD_BUSINESS_INDIVIDUAL_SELECT_COMPANY_COMPONENT_SELECT_BOX_CLICK: {
    category: 'hul_sale_contacts',
    eventType: 'click_2',
    eventParams: 'element_4',
  },
  ABROAD_BUSINESS_INDIVIDUAL_SELECT_COMPANY_COMPONENT_CONTINUE_BUTTON_CLICK: {
    category: 'hul_sale_contacts',
    eventType: 'click_3',
    eventParams: 'element_5',
  },
  ABROAD_BUSINESS_INDIVIDUAL_SELECT_COMPANY_COMPONENT_ONLY_ONE_AND_NOT_ALLOWED: {
    category: 'hul_sale_contacts',
    eventType: 'visibility_3',
    eventParams: 'element_6',
  },
  // ABROAD_BUSINESS_INDIVIDUAL_SELECT_COMPANY_COMPONENT_SELECTED_NOT_ALLOWED:{//10
  //   category: 'hul_sale_contacts',
  //   eventType: 'click_4',
  //   eventParams: 'element_7',
  // },
  ABROAD_BUSINESS_INDIVIDUAL_SELECT_COMPANY_ONLY_ONE_AND_NOT_ALLOWED_CALL_BUTTON_CLICK: {
    category: 'hul_sale_contacts',
    eventType: 'click_5',
    eventParams: 'element_8',
  },
  ABROAD_BUSINESS_INDIVIDUAL_SELECT_COMPANY_COMPONENT_FINISH_BUTTON_CLICK: {
    category: 'hul_sale_contacts',
    eventType: 'click_6',
    eventParams: 'element_9',
  },
  ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_VIEW: {
    category: 'hul_sale_contacts',
    eventType: 'visibility_4',
    eventParams: 'element_10',
  },
  ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_VIEW_ONLY_BUTTON_CLICK: {
    category: 'hul_sale_contacts',
    eventType: 'click_7',
    eventParams: 'element_11',
  },
  ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_CONTINUE_BUTTON_CLICK: {
    category: 'hul_sale_contacts',
    eventType: 'click_8',
    eventParams: 'element_12',
  },
  ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_ERROR_MESSAGE: {
    category: 'hul_sale_contacts',
    eventType: 'visibility_5',
    eventParams: [],
  },
  ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_VOICE_PACKAGE_EXISTS_POPUP: {
    category: 'hul_sale_contacts',
    eventType: 'visibility_6',
    eventParams: 'element_13',
  },
  ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_VOICE_PACKAGE_EXISTS_POPUP_BUTTON_CLICK: {
    category: 'hul_sale_contacts',
    eventType: 'click_9',
    eventParams: 'element_14',
  },
  ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_GOLD_ACCOUNT_POPUP: {
    category: 'hul_sale_contacts',
    eventType: 'visibility_7',
    eventParams: 'element_15',
  },
  ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_GOLD_ACCOUNT_POPUP_BUTTON_CLICK: {
    category: 'hul_sale_contacts',
    eventType: 'click_10',
    eventParams: 'element_16',
  },
  ABROAD_BUSINESS_INDIVIDUAL_SEARCH_PACKAGES_RESULTS: {
    //21
    category: 'hul_sale_contacts',
    eventType: 'visibility_8',
    eventParams: 'element_17',
  },
  // ABROAD_BUSINESS_INDIVIDUAL_SEARCH_PACKAGES_RESULTS_SHOW_MADAF_PACKAGES_BUTTON_CLICK: {
  //   //22
  //   category: 'hul_sale_contacts',
  //   eventType: 'click_11',
  //   eventParams: 'element_18',
  // },
  ABROAD_BUSINESS_INDIVIDUAL_SEARCH_PACKAGES_RESULTS_SELECT_ACCOUNT_STICKY_BUTTON_CLICK: {
    //23
    category: 'hul_sale_contacts',
    eventType: 'click_12',
    eventParams: 'element_19',
  },
  ABROAD_BUSINESS_INDIVIDUAL_SEARCH_PACKAGES_RESULTS_WITH_PARAMETERS: {
    category: 'hul_sale_contacts',
    eventType: 'visibility_9',
    eventParams: 'element_20',
  },
  // ABROAD_BUSINESS_INDIVIDUAL_:{//25
  //   category: 'hul_sale_contacts',
  //   eventType: 'click_12',
  //   eventParams: 'element_19',
  // },
  // ABROAD_BUSINESS_INDIVIDUAL_:{//26
  //   category: 'hul_sale_contacts',
  //   eventType: 'click_12',
  //   eventParams: 'element_19',
  // },
  ABROAD_BUSINESS_INDIVIDUAL_SEARCH_PARAMETERS_VIEW_ACCOUNT_SELECTED: {
    //27
    category: 'hul_sale_contacts',
    eventType: 'visibility_10',
    eventParams: 'element_23',
  },
  ABROAD_BUSINESS_INDIVIDUAL_CHANGE_SELECTED_ACCOUNT_BUTTON_CLICK: {
    category: 'hul_sale_contacts',
    eventType: 'click_15',
    eventParams: 'element_24',
  },
  ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_IS_CLICKED: {
    category: 'hul_sale_contacts',
    eventType: 'click_16',
    eventParams: 'element_25',
  },
  ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_IS_OPENED: {
    category: 'hul_sale_contacts',
    eventType: 'visibility_10',
    eventParams: 'element_26',
  },
  ABROAD_BUSINESS_INDIVIDUAL_LOBBY_CLOSE_SELECT_COUNTRIES_BUTTON_CLICK: {
    category: 'hul_sale_contacts',
    eventType: 'click_17',
    eventParams: 'element_27',
  },
  ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_SELECT_POPULAR_COUNTRY: {
    category: 'hul_sale_contacts',
    eventType: 'click_18',
    eventParams: [],
  },
  ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_SELECT_SEARCHED_COUNTRY: {
    category: 'hul_sale_contacts',
    eventType: 'click_19',
    eventParams: [],
  },
  ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_CONTINUE_BUTTON_IS_CLICKED: {
    category: 'hul_sale_contacts',
    eventType: 'click_20',
    eventParams: [],
  },
  ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_CONNECTED_COUNTRY_EXISTS_POPUP: {
    //35
    category: 'hul_sale_contacts',
    eventType: 'visibility_11',
    eventParams: 'element_28',
  },
  ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_ADD_COUNTRY_FROM_CONNECTED_COUNTRY_EXISTS_POPUP: {
    //36
    category: 'hul_sale_contacts',
    eventType: 'click_21',
    eventParams: 'element_29',
  },
  ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_LIMITED_COUNTRY_COUNT_POPUP: {
    category: 'hul_sale_contacts',
    eventType: 'visibility_12',
    eventParams: 'element_30',
  },
  ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_ERROR_ON_SEARCH_COUNTRY: {
    category: 'hul_sale_contacts',
    eventType: 'visibility_13',
    eventParams: [],
  },
  ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_DATES_TAB_IS_CLICKED: {
    //39
    category: 'hul_sale_contacts',
    eventType: 'click_22',
    eventParams: 'element_31',
  },
  ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_DATES_TAB_IS_OPENED: {
    //40
    category: 'hul_sale_contacts',
    eventType: 'visibility_14',
    eventParams: 'element_32',
  },
  ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_DATES_TAB_START_DATE_IS_SELECTED: {
    category: 'hul_sale_contacts',
    eventType: 'click_23',
    eventParams: 'element_33',
  },
  ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_DATES_TAB_END_DATE_IS_SELECTED: {
    category: 'hul_sale_contacts',
    eventType: 'click_24',
    eventParams: [],
  },
  ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SEARCHED_PACKAGES_ARE_SHOWN: {
    //43
    category: 'hul_sale_contacts',
    eventType: 'visibility_15',
    eventParams: 'element_34',
  },
  ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SEARCHED_PURCHASE_BUTTON_IS_CLICKED: {
    category: 'hul_sale_contacts',
    eventType: 'click_25',
    eventParams: 'element_35',
  },
  ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SEARCH_EMPTY_RESULT: {
    category: 'hul_sale_contacts',
    eventType: 'visibility_16',
    eventParams: 'element_36',
  },
  ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SEARCH_EMPTY_RESULT_ON_GENERAL_ERROR: {
    //46
    category: 'hul_sale_contacts',
    eventType: 'visibility_17',
    eventParams: 'element_37',
  },
  ABROAD_BUSINESS_INDIVIDUAL_SOC_ROAM_POPUP: {
    category: 'hul_sale_contacts',
    eventType: 'visibility_18',
    eventParams: 'element_38',
  },
  ABROAD_BUSINESS_INDIVIDUAL_SOC_ROAM_POPUP_BUTTON_CLICK_ACTION: {
    category: 'hul_sale_contacts',
    eventType: 'click_26',
    eventParams: '',
  },
  ABROAD_BUSINESS_INDIVIDUAL_TICKET_IS_SHOWN: {
    category: 'hul_sale_contacts',
    eventType: 'visibility_19',
    eventParams: [],
  },
  ABROAD_BUSINESS_INDIVIDUAL_TICKET_CHANGE_START_DATE_BUTTON_CLICK: {
    //50
    category: 'hul_sale_contacts',
    eventType: 'click_27',
    eventParams: 'element_39',
  },
  ABROAD_BUSINESS_INDIVIDUAL_TICKET_CHANGE_ACCOUNT_CLICK: {
    category: 'hul_sale_contacts',
    eventType: 'click_28',
    eventParams: 'element_40',
  },
  ABROAD_BUSINESS_INDIVIDUAL_TICKET_CHECKBOX_SELECTED: {
    category: 'hul_sale_contacts',
    eventType: 'click_29',
    eventParams: 'element_41',
  },
  ABROAD_BUSINESS_INDIVIDUAL_TICKET_ADD_PACKAGE_BUTTON_CLICK: {
    category: 'hul_sale_contacts',
    eventType: 'click_30',
    eventParams: 'element_42',
  },
  ABROAD_BUSINESS_INDIVIDUAL_TICKET_DATA_USAGE_IS_BLOCKED: {
    category: 'hul_sale_contacts',
    eventType: 'visibility_20',
    eventParams: 'element_43',
  },
  ABROAD_BUSINESS_INDIVIDUAL_TICKET_DATA_USAGE_IS_BLOCKED_BUTTON_ACTION: {
    category: 'hul_sale_contacts',
    eventType: 'click_30',
    eventParams: '',
  },
  ABROAD_BUSINESS_INDIVIDUAL_TICKET_AUTO_PACKAGE_POPUP: {
    category: 'hul_sale_contacts',
    eventType: 'visibility_21',
    eventParams: 'element_44',
  },
  ABROAD_BUSINESS_INDIVIDUAL_TICKET_AUTO_PACKAGE_POPUP_BUTTON: {
    category: 'hul_sale_contacts',
    eventType: 'click_31',
    eventParams: '',
  },
  ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_SUCCESS: {
    category: 'hul_sale_contacts',
    eventType: 'visibility_22',
    eventParams: 'element_45',
  },
  ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_SUCCESS_PURCHASE_FOR_SOMEBODY_ELSE_CLICK: {
    category: 'hul_sale_contacts',
    eventType: 'click_32',
    eventParams: [],
  },
  ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_SUCCESS_FINISH_BUTTON_CLICK: {
    category: 'hul_sale_contacts',
    eventType: 'click_33',
    eventParams: 'element_46',
  },
  ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_GENERAL_ERROR: {
    category: 'hul_sale_contacts',
    eventType: 'visibility_23',
    eventParams: 'element_47',
  },
  ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_GENERAL_ERROR_BUTTON_CLICK: {
    //62
    category: 'hul_sale_contacts',
    eventType: 'click_34',
    eventParams: '',
  },
  ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE: {
    category: 'hul_sale_contacts',
    eventType: 'visibility_24',
    eventParams: 'element_48',
  },
  ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_BUTTON_CLICK: {
    category: 'hul_sale_contacts',
    eventType: 'click_35',
    eventParams: '',
  },
  ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_ERROR_SAME_PACKAGE: {
    category: 'hul_sale_contacts',
    eventType: 'visibility_25',
    eventParams: 'element_49',
  },
  ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_ERROR_SAME_PACKAGE_BUTTON_CLICK: {
    category: 'hul_sale_contacts',
    eventType: 'click_36',
    eventParams: '',
  },
  ABROAD_MY_ABROAD_BUSINESS_INDIVIDUAL_HIDDEN_PACKAGES_MSG: {
    category: 'hul_sheli',
    eventType: 'visibility_15',
    eventParams: 'element_27',
  },
  ABROAD_MY_ABROAD_AUTO_PACKAGES_ARE_SHOWN: {
    category: 'hul_sheli',
    eventType: 'visibility_16',
    eventParams: '',
  },
  //cellcom abroad end
  ROUTER_ACTIVATION_FRONT_PAGE_DISPLAY: {
    category: 'router_activation',
    eventType: 'visibility_1',
    eventParams: 'screen_1',
  },
  ROUTER_ACTIVATION_FRONT_PAGE_CLICK_ON_YES_ROUTER_ARRIVED_BUTTON: {
    category: 'router_activation',
    eventType: 'click_1',
    eventParams: 'button_1',
  },
  ROUTER_ACTIVATION_FRONT_PAGE_CLICK_ON_NO_ROUTER_DIDNT_ARRIVED_BUTTON: {
    category: 'router_activation',
    eventType: 'click_2',
    eventParams: 'button_2',
  },
  ROUTER_ACTIVATION_WIZARD_READY_STEP_PHASE_1_DISPLAY: {
    category: 'router_activation',
    eventType: 'visibility_2',
    eventParams: 'screen_2',
  },
  ROUTER_ACTIVATION_WIZARD_READY_STEP_PHASE_2_DISPLAY: {
    category: 'router_activation',
    eventType: 'visibility_3',
    eventParams: 'screen_3',
  },
  ROUTER_ACTIVATION_WIZARD_READY_STEP_PHASE_2_CLICK_LETS_GO_BUTTON: {
    category: 'router_activation',
    eventType: 'click_3',
    eventParams: 'button_3',
  },
  ROUTER_ACTIVATION_WIZARD_PREDEFINE_STEP_DISPLAY: {
    category: 'router_activation',
    eventType: 'visibility_4',
    eventParams: 'screen_4',
  },
  ROUTER_ACTIVATION_WIZARD_PREDEFINE_STEP_CLICK_CONNECTED_BUTTON: {
    category: 'router_activation',
    eventType: 'click_4',
    eventParams: 'button_4',
  },
  ROUTER_ACTIVATION_WIZARD_UPDATE_STEP_DISPLAY: {
    category: 'router_activation',
    eventType: 'visibility_5',
    eventParams: 'screen_5',
  },
  ROUTER_ACTIVATION_WIZARD_ERROR_STEP_NO1_DISPLAY: {
    category: 'router_activation',
    eventType: 'visibility_6',
    eventParams: 'screen_6',
  },
  ROUTER_ACTIVATION_WIZARD_ERROR_STEP_NO1_CLICK_CALL_CUSTOMER_SUPPORT_BUTTON: {
    category: 'router_activation',
    eventType: 'click_5',
    eventParams: 'button_5',
  },
  ROUTER_ACTIVATION_WIZARD_DEFINE_NETWORK_STEP_PHASE_1_DISPLAY: {
    category: 'router_activation',
    eventType: 'visibility_7',
    eventParams: 'screen_7',
  },
  ROUTER_ACTIVATION_WIZARD_DEFINE_NETWORK_STEP_PHASE_1_CLICK_UPDATE_BUTTON: {
    category: 'router_activation',
    eventType: 'click_6',
    eventParams: 'button_6',
  },
  ROUTER_ACTIVATION_WIZARD_DEFINE_NETWORK_STEP_PHASE_2_DISPLAY: {
    category: 'router_activation',
    eventType: 'visibility_8',
    eventParams: 'screen_8',
  },
  ROUTER_ACTIVATION_WIZARD_ERROR_STEP_NO2_DISPLAY: {
    category: 'router_activation',
    eventType: 'visibility_9',
    eventParams: 'screen_9',
  },
  ROUTER_ACTIVATION_WIZARD_ERROR_STEP_NO2_CLICK_CALL_CUSTOMER_SUPPORT_BUTTON: {
    category: 'router_activation',
    eventType: 'click_7',
    eventParams: 'button_7',
  },
  ROUTER_ACTIVATION_WIZARD_COMPLETE_STEP_DISPLAY: {
    category: 'router_activation',
    eventType: 'visibility_10',
    eventParams: 'screen_10',
  },
  ROUTER_ACTIVATION_WIZARD_COMPLETE_STEP_CLICK_SCREEN_CAPTURE_BUTTON: {
    category: 'router_activation',
    eventType: 'click_8',
    eventParams: 'button_8',
  },
  ROUTER_ACTIVATION_WIZARD_COMPLETE_STEP_CLICK_FINISH_BUTTON: {
    category: 'router_activation',
    eventType: 'click_10',
    eventParams: 'button_10',
  },
  TV_NEW_SALE_PAGE_LOAD: {
    category: 'tv_newsale_process',
    eventType: 'visibility_1',
    eventParams: 'screen_1',
  },

  TV_NEW_SALE_ACTION_CLICK: {
    category: 'tv_newsale_process',
    eventType: 'click_1',
    eventParams: [],
  },
  GENERAL_NEW_SALE_ACTION_CLICK: {
    category: 'sim_esim_process',
    eventType: 'בחירת חבילה',
    eventParams: [],
  },
  APP_NEW_SALE_SUPPORTED_TV_OPEN: {
    category: 'app_newsale_process',
    eventType: 'click_36',
    eventParams: [],
  },
  //מכר בהפרדה
  SEPARATED_CELLCOMWORKER_NOTICE: {
    category: 'hul_sale_separate',
    eventType: 'visibility_1',
    eventParams: 'element_1',
  },
  SEPARATED_INACTIVEUSER_NOTICE: {
    category: 'hul_sale_separate',
    eventType: 'visibility_2',
    eventParams: 'element_2',
  },
  SEPARATED_NOROAM_NOTICE: {
    category: 'hul_sale_separate',
    eventType: 'visibility_3',
    eventParams: 'element_3',
  },
  SEPARATED_GENERALERROR_NOTICE: {
    category: 'hul_sale_separate',
    eventType: 'visibility_4',
    eventParams: 'element_4',
  },
  SEPARATED_BLOCKSOC_NOTICE: {
    category: 'hul_sale_separate',
    eventType: 'visibility_5',
    eventParams: 'element_5',
  },
  SEPARATED_NOTCELLCOM_NOTICE: {
    category: 'hul_sale_separate',
    eventType: 'visibility_6',
    eventParams: 'element_6',
  },
  SEPARATED_AUTOMATICSOC_NOTICE: {
    category: 'hul_sale_separate',
    eventType: 'visibility_7',
    eventParams: 'element_7',
  },
  SEPARATED_ROLLINGSOC_NOTICE: {
    category: 'hul_sale_separate',
    eventType: 'visibility_9',
    eventParams: 'element_9',
  },
  SEPARATED_DEFAULTSOC_NOTICE: {
    category: 'hul_sale_separate',
    eventType: 'visibility_8',
    eventParams: 'element_8',
  },
  SEPARATED_NOSHADOWSOC_NOTICE: {
    category: 'hul_sale_separate',
    eventType: 'visibility_10',
    eventParams: 'element_10',
  },
  SEPARATED_NOTBUSINESSUSER_NOTICE: {
    category: 'hul_sale_separate',
    eventType: 'visibility_11',
    eventParams: 'element_11',
  },
  SEPARATED_LOBBYAFTEROTP_SHOW: {
    category: 'hul_sale_separate',
    eventType: 'visibility_12',
    eventParams: 'element_12',
  },
  SEPARATED_COUNTRYDEFINITION_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_1',
    eventParams: 'element_13',
  },
  SEPARATED_DATEDEFINITION_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_2',
    eventParams: 'element_14',
  },
  SEPARATED_SEARCHBUTTON_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_3',
    eventParams: 'element_15',
  },
  SEPARATED_POPULARPACKAGES_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_13',
    eventParams: 'element_16',
  },
  SEPARATED_PURCHASEBUTTON_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_4',
    eventParams: [],
  },
  SEPARATED_SUPPORTEDCOUNTRIES_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_5',
    eventParams: 'element_17',
  },
  SEPARATED_IMPORTANTTOKNOW_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_6',
    eventParams: 'element_18',
  },
  SEPARATED_COUNTRYDESTINATIONS_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_14',
    eventParams: 'element_19',
  },
  SEPARATED_XCLOSE_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_7',
    eventParams: 'element_20',
  },
  SEPARATED_POPULARDESTINATIONCHOOSE_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_8',
    eventParams: [],
  },
  SEPARATED_SEARCHDESTINATIONCHOOSE_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_9',
    eventParams: [],
  },
  SEPARATED_DESTINATIONCONTINUE_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_10',
    eventParams: [],
  },
  SEPARATED_ADDDESTINATION_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_15',
    eventParams: 'element_21',
  },
  SEPARATED_ADDDESTINATION_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_11',
    eventParams: 'element_22',
  },
  SEPARATED_MORETHAN5_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_16',
    eventParams: 'element_23',
  },
  SEPARATED_DESTINATIONNOTFOUND_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_17',
    eventParams: [],
  },
  SEPARATED_CHOOSEDATES_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_18',
    eventParams: 'element_24',
  },
  SEPARATED_STARTDATE_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_12',
    eventParams: 'element_25',
  },
  SEPARATED_ENDDATE_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_13',
    eventParams: [],
  },
  SEPARATED_SEARCHRESULTS_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_19',
    eventParams: [],
  },
  SEPARATED_SHOWMORE_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_14',
    eventParams: 'element_26',
  },
  SEPARATED_LESSFITTINGPACKAGES_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_15',
    eventParams: 'element_27',
  },
  SEPARATED_PACKAGESHOWN_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_20',
    eventParams: [],
  },
  SEPARATED_SEARCHPACKAGEBUY_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_16',
    eventParams: 'element_28',
  },
  SEPARATED_SUPPORTEDCOUNTRIESSEARCH_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_17',
    eventParams: 'element_29',
  },
  SEPARATED_IMPORTANTTOKNOWSEARCH_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_18',
    eventParams: 'element_30',
  },
  SEPARATED_WHYBUYPACKAGE_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_21',
    eventParams: [],
  },
  SEPARATED_MOMENTBEFOREFLIGHT_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_22',
    eventParams: [],
  },
  SEPARATED_OPENDEVICETOHUL_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_19',
    eventParams: [],
  },
  SEPARATED_IMPORTANTTOKNOWBEFOREFLIGHT: {
    category: 'hul_sale_seperate',
    eventType: 'click_20',
    eventParams: [],
  },
  SEPARATED_FAQZONE_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_23',
    eventParams: [],
  },
  SEPARATED_FAQQUESTION_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_21',
    eventParams: [],
  },
  SEPARATED_CONTACTSERVICES_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_24',
    eventParams: [],
  },
  SEPARATED_CONTACTSERVICES_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_22',
    eventParams: [],
  },
  SEPARATED_TARIFFZONEBUTTON_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_25',
    eventParams: [],
  },
  SEPARATED_TARIFFZONEBUTTON_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_35',
    eventParams: [],
  },
  SEPARATED_IDSCREEN_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_26',
    eventParams: 'element_31',
  },
  SEPARATED_IDSCREENCONTINUE_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_36',
    eventParams: 'element_32',
  },
  SEPARATED_CUSTOMERINDEBT_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_27',
    eventParams: 'element_33',
  },
  SEPARATED_IDDOESNTMATCH_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_28',
    eventParams: 'element_34',
  },
  SEPARATED_TONEWACCOUNT_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_37',
    eventParams: 'element_35',
  },
  SEPARATED_CANTGOTONEW_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_29',
    eventParams: 'element_36',
  },
  SEPARATED_IDSCREENCONTINUEAFTERERRORS_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_38',
    eventParams: 'element_37',
  },
  SEPARATED_DETAILINSERTSCREEN_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_30',
    eventParams: 'element_38',
  },
  SEPARATED_DETAILCONTINUE_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_39',
    eventParams: 'element_39',
  },
  SEPARATED_DETAILDEBT_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_31',
    eventParams: 'element_40',
  },
  SEPARATED_DIFFERENTID_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_40',
    eventParams: 'element_41',
  },
  SEPARATED_CCINSERTSCREEN_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_32',
    eventParams: 'element_42',
  },
  SEPARATED_CCINSERTCONTINUE_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_41',
    eventParams: 'element_43',
  },
  SEPARATED_CCUPDATEFAILED_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_33',
    eventParams: 'element_44',
  },
  SEPARATED_CONTINUEWITHCURRENTPAYMENT_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_42',
    eventParams: 'element_45',
  },
  SEPARATED_LOADERSCREEN_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_34',
    eventParams: 'element_46',
  },
  SEPARATED_TICKETSCREEN_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_35',
    eventParams: [],
  },
  SEPARATED_CHANGEDATESOPENTICKET_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_43',
    eventParams: 'element_47',
  },
  SEPARATED_UPDATEPAYMENTOPENTICKET_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_44',
    eventParams: 'element_48',
  },
  SEPARATED_UPDATEMAILOPENTICKET_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_45',
    eventParams: 'element_49',
  },
  SEPARATED_PACKAGETERMSTICKET_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_46',
    eventParams: 'element_50',
  },
  SEPARATED_TERMSACCEPTTICKET_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_47',
    eventParams: 'element_51',
  },
  SEPARATED_PACKAGEINSTALL_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_48',
    eventParams: 'element_52',
  },
  SEPARATED_MAILUPDATE_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_36',
    eventParams: 'element_53',
  },
  SEPARATED_UPDATEMAILSEND_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_49',
    eventParams: 'element_54',
  },
  SEPARATED_UPDATEMAILCANCEL_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_50',
    eventParams: 'element_55',
  },
  SEPARATED_INVALIDMAILINUPDATE_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_37',
    eventParams: 'element_56',
  },
  SEPARATED_SUCCESSFULUPDATEMAIL_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_38',
    eventParams: 'element_57',
  },
  SEPARATED_MAILUPDATEFAILURE_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_39',
    eventParams: 'element_58',
  },
  SEPARATED_MAILUPDATEFAILUREOUTSIDEHOURS_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_40',
    eventParams: 'element_59',
  },
  SEPARATED_MAILUPDATECALLME_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_51',
    eventParams: 'element_60',
  },
  SEPARATED_INSTALLEDSUCCESSFULLY_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_41',
    eventParams: 'element_61',
  },
  SEPARATED_SUCCESSFINISHINSTALLED_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_52',
    eventParams: 'element_62',
  },
  SEPARATED_ERRORINSTALLPACKAGE_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_42',
    eventParams: 'element_63',
  },
  SEPARATED_ERRORCALLERBUTTON_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_53',
    eventParams: 'element_64',
  },
  SEPARATED_ERRORFINISHINSTALLED_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_54',
    eventParams: 'element_65',
  },
  SEPARATED_FAILEDINSTALLPACKAGE_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_43',
    eventParams: 'element_66',
  },
  SEPARATED_FAILEDCALLERBUTTON_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_56',
    eventParams: 'element_68',
  },
  SEPARATED_FAILEDFINISHINSTALLED_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_57',
    eventParams: 'element_69',
  },
  SEPARATED_FAILEDINSTALLHULSHELI_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_55',
    eventParams: 'element_67',
  },
  SEPARATED_FROMPACKAGECHOOSEDESTINATIONS_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_44',
    eventParams: 'element_70',
  },
  SEPARATED_FROMPACKAGEX_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_58',
    eventParams: 'element_71',
  },
  SEPARATED_FROMPACKAGECHOOSEDESTINATIONPOPULAR_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_59',
    eventParams: [],
  },
  SEPARATED_FROMPACKAGECHOOSEDESTINATIONSEARCH_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_60',
    eventParams: [],
  },
  SEPARATED_FROMPACKAGEDESTINATIONSCONTINUE_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_61',
    eventParams: [],
  },
  SEPARATED_FROMPACKAGEDESTINATIONADDITIONMESSAGE_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_45',
    eventParams: 'element_72',
  },
  SEPARATED_FROMPACKAGEDESTINATIONADDITIONMESSAGEADD_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_62',
    eventParams: 'element_73',
  },
  SEPARATED_FROMPACKAGEMORETHANFIVEDESTINATIONS_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_46',
    eventParams: 'element_74',
  },
  SEPARATED_FROMPACKAGENODESTINATIONMATCH_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_47',
    eventParams: [],
  },
  SEPARATED_FROMPACKAGEDESTINATIONNOTSUPPORTED_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_48',
    eventParams: 'element_75',
  },
  SEPARATED_FROMPACKAGEDESTINATIONNOTSUPPORTEDCONTINUE_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_63',
    eventParams: 'element_76',
  },
  SEPARATED_FROMPACKAGEDESTINATIONNOTSUPPORTEDCHECKAGAIN_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_64',
    eventParams: 'element_77',
  },
  SEPARATED_FROMPACKAGESPECIFICCOUNTRYUNSUPPORTED_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_49',
    eventParams: 'element_78',
  },
  SEPARATED_FROMPACKAGECOUNTRYUNSUPPORTEDWHATDO_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_65',
    eventParams: 'element_79',
  },
  SEPARATED_FROMPACKAGECOUNTRYUNSUPPORTEDSEARCHPACKAGE_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_66',
    eventParams: 'element_80',
  },
  SEPARATED_FROMPACKAGECOUNTRYUNSUPPORTEDCONTINUE_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_67',
    eventParams: 'element_81',
  },
  SEPARATED_FROMSPACKAGEDESTINATIONNOTFOUND_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_50',
    eventParams: [],
  },
  SEPARATED_FROMPACKAGECHOOSEDATES_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_51',
    eventParams: 'element_82',
  },
  SEPARATED_FROMPACKAGESTARTDATE_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_68',
    eventParams: 'element_83',
  },
  SEPARATED_FROMPACKAGEENDDATE_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_69',
    eventParams: [],
  },
  SEPARATED_FROMPACKAGERANGEBIGGERTHANPACKAGE_SHOW: {
    category: 'hul_sale_seperate',
    eventType: 'visibility_52',
    eventParams: 'element_84',
  },
  SEPARATED_FROMPACKAGERANGEBIGGERWHATDO_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_70',
    eventParams: 'element_85',
  },
  SEPARATED_FROMPACKAGERANGEBIGGERSEARCHMORE_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_71',
    eventParams: 'element_86',
  },
  SEPARATED_FROMPACKAGERANGEBIGGERCONTINUEWITHPACKAGE_CLICK: {
    category: 'hul_sale_seperate',
    eventType: 'click_72',
    eventParams: 'element_87',
  },
  //תשלום חוב פרטי
  PRIVATEDEBT_ENTER_PAGE: {
    category: 'debt_payment_private',
    eventType: 'visibility_1',
    eventParams: [],
  },
  PRIVATEDEBT_CHOOSEACCOUNT_SHOW: {
    category: 'debt_payment_private',
    eventType: 'visibility_2',
    eventParams: [],
  },
  PRIVATEDEBT_CHOOSEACCOUNT_CLICK: {
    category: 'debt_payment_private',
    eventType: 'click_1',
    eventParams: 'element_1',
  },
  PRIVATEDEBT_ACCOUNTSHOW_CALL_CLICK: {
    category: 'debt_payment_private',
    eventType: 'click_2',
    eventParams: 'element_2',
  },
  PRIVATEDEBT_GENERALERROR_SHOW: {
    category: 'debt_payment_private',
    eventType: 'visibility_3',
    eventParams: 'element_3',
  },
  PRIVATEDEBT_SPECIALERROR_SHOW: {
    category: 'debt_payment_private',
    eventType: 'visibility_4',
    eventParams: [],
  },
  PRIVATEDEBT_ADDTOCALENDAR_CLICK: {
    category: 'debt_payment_private',
    eventType: 'click_3',
    eventParams: [],
  },
  PRIVATEDEBT_SPECIALERROR_CALL_CLICK: {
    category: 'debt_payment_private',
    eventType: 'click_4',
    eventParams: [],
  },
  PRIVATEDEBT_SPECIALERROR_END_CLICK: {
    category: 'debt_payment_private',
    eventType: 'click_5',
    eventParams: [],
  },
  PRIVATEDEBT_PAYMENTPAGE_SHOW: {
    category: 'debt_payment_private',
    eventType: 'visibility_5',
    eventParams: 'element_4',
  },
  PRIVATEDEBT_PAYMENTPAGE_TOOLTIP_CLICK: {
    category: 'debt_payment_private',
    eventType: 'click_6',
    eventParams: 'element_5',
  },
  PRIVATEDEBT_PAYMENTPAGE_CONTINUE_CLICK: {
    category: 'debt_payment_private',
    eventType: 'click_7',
    eventParams: 'element_6',
  },
  PRIVATEDEBT_PAYMENTSUCCESS_SHOW: {
    category: 'debt_payment_private',
    eventType: 'visibility_6',
    eventParams: [],
  },
  PRIVATEDEBT_PAYMENTSUCCESS_UPDATEPAYMENT_CLICK: {
    category: 'debt_payment_private',
    eventType: 'click_8',
    eventParams: [],
  },
  PRIVATEDEBT_PAYMENTSUCCESS_END_CLICK: {
    category: 'debt_payment_private',
    eventType: 'click_9',
    eventParams: [],
  },
  PRIVATEDEBT_PAYMENTFAIL_SHOW: {
    category: 'debt_payment_private',
    eventType: 'visibility_7',
    eventParams: 'element_7',
  },
  PRIVATEDEBT_PAYMENTFAIL_CALL_CLICK: {
    category: 'debt_payment_private',
    eventType: 'click_10',
    eventParams: 'element_8',
  },
  PRIVATEDEBT_PAYMENTFAIL_CONTACTME_INIT_CLICK: {
    category: 'debt_payment_private',
    eventType: 'click_11',
    eventParams: 'element_9',
  },
  PRIVATEDEBT_PAYMENTFAIL_UPDATEPAYMENT_CLICK: {
    category: 'debt_payment_private',
    eventType: 'click_12',
    eventParams: 'element_10',
  },
  PRIVATEDEBT_PAYMENTFAIL_END_CLICK: {
    category: 'debt_payment_private',
    eventType: 'click_13',
    eventParams: 'element_11',
  },
  PRIVATEDEBT_CONTACTME_SHOW: {
    category: 'debt_payment_private',
    eventType: 'visibility_8',
    eventParams: 'element_12',
  },
  PRIVATEDEBT_CONTACTME_SEND_CLICK: {
    category: 'debt_payment_private',
    eventType: 'click_14',
    eventParams: 'element_13',
  },
  PRIVATEDEBT_CONTACTME_SENTSUCCESS_SHOW: {
    category: 'debt_payment_private',
    eventType: 'visibility_9',
    eventParams: 'element_14',
  },
  PRIVATEDEBT_CONTACTME_SENTFAILED_SHOW: {
    category: 'debt_payment_private',
    eventType: 'visibility_10',
    eventParams: 'element_15',
  },
  PERSONAL_DETAILS_UPDATE_POPUP_BENEFIT_SHOW: {
    category: 'personal_details_update',
    eventType: 'visibility_1',
    eventParams: '',
  },
  PERSONAL_DETAILS_UPDATE_POPUP_BENEFIT_BUTTON_CLICK_UPDATE_DETAILS: {
    category: 'personal_details_update',
    eventType: 'click_1',
    eventParams: '',
  },
  PERSONAL_DETAILS_UPDATE_POPUP_BENEFIT_BUTTON_CLICK_ANOTHER_TIME: {
    category: 'personal_details_update',
    eventType: 'click_2',
    eventParams: '',
  },
  PERSONAL_DETAILS_UPDATE_POPUP_ALREADY_USED_BENEFIT_SHOW: {
    category: 'personal_details_update',
    eventType: 'visibility_2',
    eventParams: '',
  },
  PERSONAL_DETAILS_UPDATE_POPUP_ALREADY_USED_BENEFIT_BUTTON_CLICK_UPDATE_DETAILS: {
    category: 'personal_details_update',
    eventType: 'click3',
    eventParams: '',
  },
  PERSONAL_DETAILS_UPDATE_POPUP_ALREADY_USED_BENEFIT_BUTTON_CLICK_ANOTHER_TIME: {
    category: 'personal_details_update',
    eventType: 'click4',
    eventParams: '',
  },
  PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_WITH_BENEFIT_SHOW: {
    category: 'personal_details_update',
    eventType: 'visibility_3',
    eventParams: 'element_1',
  },
  PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_WITH_BENEFIT_CHECKBOX_AGREE_TERMS_CHECKED: {
    category: 'personal_details_update',
    eventType: 'click_5',
    eventParams: 'element_2',
  },
  PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_WITH_BENEFIT_BUTTON_CLICK_UPDATE_DETAILS: {
    category: 'personal_details_update',
    eventType: 'click_6',
    eventParams: '',
  },
  PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_SUCCESS: {
    category: 'personal_details_update',
    eventType: 'visibility_4',
    eventParams: '',
  },
  PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_FAILED: {
    category: 'personal_details_update',
    eventType: 'visibility_5',
    eventParams: '',
  }
  ,
  PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_FAILED_BENEFIT_ISSUE: {
    category: 'personal_details_update',
    eventType: 'visibility_6',
    eventParams: '',
  },
  PERSONAL_DETAILS_UPDATE_POPUP_WITHOUT_BENEFIT_SHOW: {
    category: 'personal_details_update',
    eventType: 'visibility_7',
    eventParams: 'element_3',
  },
  PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_WITHOUT_BENEFIT_SHOW: {
    category: 'personal_details_update',
    eventType: 'visibility_8',
    eventParams: 'element_4',
  },
  PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_WITHOUT_BENEFIT_CHECKBOX_AGREE_TERMS_CHECKED: {
    category: 'personal_details_update',
    eventType: 'click_7',
    eventParams: 'element_5',
  },
  PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_WITHOUT_BENEFIT_BUTTON_CLICK_UPDATE_DETAILS: {
    category: 'personal_details_update',
    eventType: 'click_8',
    eventParams: 'element_6',
  },
  PERSONAL_DETAILS_UPDATE_POPUP_WITHOUT_BENEFIT_BUTTON_CLICK_UPDATE_DETAILS: {
    category: 'personal_details_update',
    eventType: 'click_9',
    eventParams: 'element_7',

  },
  PERSONAL_DETAILS_UPDATE_POPUP_WITHOUT_BENEFIT_BUTTON_CLICK_ANOTHER_TIME: {
    category: 'personal_details_update',
    eventType: 'click_10',
    eventParams: 'element_8',
  },
 
   PERSONAL_DETAILS_UPDATE_POPUP_OUT_OF_STOCK_OUT_OF_STOCK_BENEFIT_SHOW: {
    category: 'personal_details_update',
    eventType: 'visibility_9',
    eventParams: '',
  },
  
  PERSONAL_DETAILS_UPDATE_POPUP_OUT_OF_STOCK_BENEFIT_BUTTON_CLICK_UPDATE_DETAILS: {
    category: 'personal_details_update',
    eventType: 'click_11',
    eventParams: '',
  },
  PERSONAL_DETAILS_UPDATE_POPUP_OUT_OF_STOCK_BENEFIT_BUTTON_CLICK_ANOTHER_TIME: {
    category: 'personal_details_update',
    eventType: 'click_12',
    eventParams: '',
  },



};

export default constants;
